/* Cotizador */
const Selectors = {
  MONEY_REGEX: /\B(?=(\d{3})+(?!\d))/g,
  price: {
    totalInput: "input[name='total-precio']",
    totalHtml: ".precio"
  },
  buttons: {
    submit: ".botones .agregar",
    reset: ".botones .volver"
  },
  accordion: {
    titles: ".title-select-h1",
    subtitles: ".title-select-h4",
    options: ".option",
    labelRadios: ".label-colores",
    regionSelect: ".region-select",
    regionComuna: ".region-comuna",
    regionDireccion: ".region-direccion",
    radioContainer: ".radio-container",
    radioMessageContainer: ".radio-message-container",
    addressContainer: ".address-container",
    comunasSelect: ".region-comunas",
    previewImage: ".inner-image",
    previewImageZoom: ".inner-image-zoom"
  },
  form: {
    cortinaTipos: "input[name='cortina-tipos']",
    confeccionTipos: "input[name='confeccion-tipos']",
    cortinaTipoCortinas: "input[name='tipo-cortinas']",
    cortinaInstalaciones: "input[name='cortina-instalaciones']",
    ancho: "input[name='ancho']",
    alto: "input[name='alto']",
    telaTipos: "input[name='tela-tipos']",
    telaSuboptions: "input[name='tela-suboptions']",
    telaColores: "input[name='tela-opcion-colores']",
    accionamientoTipos: "input[name='accionamiento-tipos']",
    controlMotor: "input[name='control-motor']",
    caidaSentidos: "input[name='caida-sentidos']",
    cantidadPanos: "input[name='cantidad-panos']",
    mandosPosiciones: "input[name='mando-posiciones']",
    colorAccesorios: "input[name='color-accesorios']",
    instalacionTipo: "input[name='instalacion-tipos']",
    instalacionRegion: "select[name='instalacion-region']",
    instalacionComuna: "select[name='instalacion-comuna']",
    instalacionDireccion: "input[name='instalacion-direccion']",
    instalacionNombre: "#nombre",
    instalacionMensaje: "#mensaje",
    metraje: "input[name='metraje']",
    servicioTipos: "input[name='servicio-tipos']",
    servicioInstalacion: "input[name='instalacion']",
    servicioDespacho: "input[name='despacho']",
    botonVolver: ".botones .btn.volver"
  },
  cotizacion: {
    cortinaTipo: ".val-cortina-tipo",
    confeccionTipo: ".val-confeccion-tipo",
    cortinaTipoCortina: ".val-tipo-cortina",
    cortinaInstalacion: ".val-instalacion",
    ancho: ".val-ancho",
    alto: ".val-alto",
    telaTipo: ".val-tela-tipo",
    telaSuboption: ".val-tela-suboption",
    telaColor: ".val-color",
    cantidadPano: ".val-cantidad-pano",
    accionamientoTipo: ".val-accionamiento-tipo",
    caidaSentido: ".val-caida-sentido",
    colorAccesorio: ".val-color-accesorio",
    posicionMando: ".val-posicion-mando",
    instalacionCortina: ".val-instalacion-cortina",
    metraje: ".val-metraje",
    precioTela: ".val-precio-tela",
    precioCortina: ".val-precio-cortina",
    precioInstalacion: ".val-precio-instalacion",
    precioDespacho: ".val-precio-despacho"
  },
  formCotizado: {
    cortinaTipo: "input[name='form-cortina-tipo']",
    confeccionTipo: "input[name='form-confeccion-tipo']",
    ancho: "input[name='form-ancho']",
    alto: "input[name='form-alto']",
    telaTipo: "input[name='form-tela-tipo']",
    telaSuboption: "input[name='form-tela-suboption']",
    telaOpcionColor: "input[name='form-tela-opcion-color']",
    accionamientoTipo: "input[name='form-accionamiento-tipo']",
    caidaSentido: "input[name='form-caida-sentido']",
    cantidadPano: "input[name='form-cantidad-pano']",
    mandoPosicion: "input[name='form-mando-posicion']",
    colorAccesorio: "input[name='form-color-accesorio']",
    cortinaInstalacion: "input[name='form-cortina-instalacion']",
    instalacion: "input[name='form-instalacion']",
    instalacionRegion: "input[name='form-instalacion-region']",
    instalacionComuna: "input[name='form-instalacion-comuna']",
    instalacionDireccion: "input[name='form-instalacion-direccion']",
    nombre: "input[name='form-nombre']",
    mensaje: "input[name='form-mensaje']",
    homologadoVenta: "input[name='form-homologado-venta']"
  },
  formularioCotizado: {
    producto: "input[name='producto-cotizado']",
    ancho: "input[name='ancho-cotizado']",
    alto: "input[name='alto-cotizado']",
    tela: "input[name='tela-cotizado']",
    color: "input[name='color-cotizado']",
    metraje: "input[name='metraje-cotizado']",
    tipoCortina: "input[name='tipo-cortina-cotizado']",
    precioTela: "input[name='precio-tela-cotizado']",
    precioCortina: "input[name='precio-cortina-cotizado']",
    precioInstalacion: "input[name='precio-instalacion-cotizado']",
    precioDespacho: "input[name='precio-despacho-cotizado']"
  },
  hiddenFormProductos: {
    sujetadorCadena: "input[name='product-sujetador-cadena']",
    unidadControl: "input[name='product-unidad-control']",
    cadena: "input[name='product-cadena']",
    cierreCadena: "input[name='product-cierre-cadena']",
    clipTope: "input[name='product-clip-tope']",
    terminalRielInferior: "input[name='product-terminal-riel-inferior']",
    rielInferior: "input[name='product-riel-inferior']",
    tubo: "input[name='product-tubo']",
    motor: "input[name='product-motor']",
    motorControl: "input[name='product-motor-control']",
    telaRoller: "input[name='product-tela-roller']",
    zuncho: "input[name='product-zuncho']",
    rollerPlus: "input[name='product-roller-plus']",
    confeccion: "input[name='product-confeccion']",
    instalacion: "input[name='producto-instalacion']",
    pesoEnvio: "input[name='producto-peso-envio']",
    homologadoVenta: "input[name='producto-homologado-venta']"
  },
  hiddenFormProductosDuo: {
    unidadControl: "input[name='product-unidad-control-duo']",
    rielCenefa: "input[name='product-riel-cenefa-duo']",
    bracket: "input[name='product-bracket-duo']",
    rielInferior: "input[name='product-riel-inferior-duo']",
    rielTuboInferior: "input[name='product-riel-tubo-inferior-duo']",
    setTerminal: "input[name='product-set-terminal-duo']",
    sujetadorCadena: "input[name='product-sujetador-cadena-duo']",
    tubo: "input[name='product-tubo-duo']",
    cierreCadena: "input[name='product-cierre-cadena-duo']",
    clipTope: "input[name='product-clip-tope-duo']",
    cadena: "input[name='product-cadena-duo']",
    motor: "input[name='product-motor-duo']",
    motorControl: "input[name='product-motor-control-duo']",
    telaRoller: "input[name='product-tela-roller-duo']",
    confeccion: "input[name='product-confeccion-duo']",
    instalacion: "input[name='producto-instalacion-duo']",
    pesoEnvio: "input[name='producto-peso-envio-duo']",
    homologadoVenta: "input[name='producto-homologado-venta-duo']"
  },
  hiddenProducto: {
    sujetadorCadena: ".normal-products .product-sujetador-cadena",
    unidadControl: ".normal-products .product-unidad-control",
    cadena: ".normal-products .product-cadena",
    cierreCadena: ".normal-products .product-cierre-cadena",
    clipTope: ".normal-products .product-clip-tope",
    terminalRielInferior: ".normal-products .product-terminal-riel-inferior",
    rielInferior: ".normal-products .product-riel-inferior",
    tubo: ".normal-products .product-tubo",
    motor: ".normal-products .product-motor",
    motorControl: ".normal-products .product-motor-control",
    telaRoller: ".normal-products .product-tela-roller",
    zuncho: ".product-zuncho",
    rollerPlus: ".normal-products .product-cenefa-extra",
    confeccion: ".product-confeccion",
    instalacion: ".product-instalacion"
  },
  hiddenProductoDuo: {
    unidadControl: ".duo-products .product-unidad-control-duo",
    rielCenefa: ".duo-products .product-riel-cenefa-duo",
    bracket: ".duo-products .product-bracket-duo",
    rielInferior: ".duo-products .product-riel-inferior-duo",
    rielTuboInferior: ".duo-products .product-riel-tubo-inferior-duo",
    setTerminal: ".duo-products .product-set-terminal-duo",
    sujetadorCadena: ".duo-products .product-sujetador-cadena-duo",
    tubo: ".duo-products .product-tubo-duo",
    cierreCadena: ".duo-products .product-cierre-cadena-duo",
    clipTope: ".duo-products .product-clip-tope-duo",
    cadena: ".duo-products .product-cadena-duo",
    telaRoller: ".duo-products .product-tela-roller-duo",
    motor: ".duo-products .product-motor-duo",
    motorControl: ".duo-products .product-motor-control-duo",
    confeccion: ".product-confeccion-duo",
    instalacion: ".product-instalacion-duo"
  },
  printCotizacion: {
    area: ".inner-cotizacion-content"
  }
};

const PLUS_PRICE_GUARD_VALUE                      = 999999;

const MONEY_REGEX                                 = Selectors.MONEY_REGEX;

const total_precio_input                          = document.querySelector(Selectors.price.totalInput);
const total_precio_html                           = document.querySelector(Selectors.price.totalHtml);
// Buttons
const button_submit                               = document.querySelector(Selectors.buttons.submit);
const button_reset                                = document.querySelector(Selectors.buttons.reset);
// Acordeon
const cotiza_titles                               = document.querySelectorAll(Selectors.accordion.titles);
const cotiza_subtitles                            = document.querySelectorAll(Selectors.accordion.subtitles);
const cotiza_options                              = document.querySelectorAll(Selectors.accordion.options);
const label_radios                                = document.querySelectorAll(Selectors.accordion.labelRadios);
const region_select                               = document.querySelector(Selectors.accordion.regionSelect);
const region_comuna                               = document.querySelector(Selectors.accordion.regionComuna);
const region_direccion                            = document.querySelector(Selectors.accordion.regionDireccion);
const radio_container                             = document.querySelector(Selectors.accordion.radioContainer);
const radio_message_container                     = document.querySelector(Selectors.accordion.radioMessageContainer);
const address_container                           = document.querySelector(Selectors.accordion.addressContainer);
const comunas_select                              = document.querySelector(Selectors.accordion.comunasSelect);
const preview_image                               = document.querySelector(Selectors.accordion.previewImage);
const preview_image_zoom                          = document.querySelector(Selectors.accordion.previewImageZoom);
// Formulario
const input_cortina_tipos                         = document.querySelectorAll(Selectors.form.cortinaTipos);
const input_confeccion_tipos                      = document.querySelectorAll(Selectors.form.confeccionTipos);
const input_ancho                                 = document.querySelector(Selectors.form.ancho);
const input_alto                                  = document.querySelector(Selectors.form.alto);
const input_tela_tipos                            = document.querySelectorAll(Selectors.form.telaTipos);
const input_tela_suboptions                       = document.querySelectorAll(Selectors.form.telaSuboptions);
const input_tela_opcion_colores                   = document.querySelectorAll(Selectors.form.telaColores);
const input_accionamiento_tipos                   = document.querySelectorAll(Selectors.form.accionamientoTipos);
const input_control_motor                         = document.querySelector(Selectors.form.controlMotor);
const input_caida_sentidos                        = document.querySelectorAll(Selectors.form.caidaSentidos);
const input_cantidad_panos                        = document.querySelectorAll(Selectors.form.cantidadPanos);
const input_tipo_cortinas                         = document.querySelectorAll(Selectors.form.cortinaTipoCortinas);
const input_mando_posiciones                      = document.querySelectorAll(Selectors.form.mandosPosiciones);
const input_color_accesorios                      = document.querySelectorAll(Selectors.form.colorAccesorios);
const input_cortina_instalaciones                 = document.querySelectorAll(Selectors.form.cortinaInstalaciones);
const input_instalacion_tipos                     = document.querySelectorAll(Selectors.form.instalacionTipo);
const input_instalacion_region                    = document.querySelector(Selectors.form.instalacionRegion);
const input_instalacion_comuna                    = document.querySelector(Selectors.form.instalacionComuna);
const input_instalacion_direccion                 = document.querySelector(Selectors.form.instalacionDireccion);
const input_nombre                                = document.querySelector(Selectors.form.instalacionNombre);
const input_mensaje                               = document.querySelector(Selectors.form.instalacionMensaje);
const reset_button                                = document.querySelector(Selectors.form.botonVolver);
// Cotización
const cotizacion_cortina_tipo                     = document.querySelector(Selectors.cotizacion.cortinaTipo);
const cotizacion_confeccion_tipo                  = document.querySelector(Selectors.cotizacion.confeccionTipo);
const cotizacion_ancho                            = document.querySelector(Selectors.cotizacion.ancho);
const cotizacion_alto                             = document.querySelector(Selectors.cotizacion.alto);
const cotizacion_tela_tipo                        = document.querySelector(Selectors.cotizacion.telaTipo);
const cotizacion_tela_suboption                   = document.querySelector(Selectors.cotizacion.telaSuboption);
const cotizacion_cantidad_pano                    = document.querySelector(Selectors.cotizacion.cantidadPano);
const cotizacion_tipo_cortina                     = document.querySelector(Selectors.cotizacion.cortinaTipoCortina);
const cotizacion_accionamiento_tipo               = document.querySelector(Selectors.cotizacion.accionamientoTipo);
const cotizacion_caida_sentido                    = document.querySelector(Selectors.cotizacion.caidaSentido);
const cotizacion_color_accesorio                  = document.querySelector(Selectors.cotizacion.colorAccesorio);
const cotizacion_posicion_mando                   = document.querySelector(Selectors.cotizacion.posicionMando);
const cotizacion_instalacion_cortina              = document.querySelector(Selectors.cotizacion.instalacionCortina);
const cotizacion_instalacion                      = document.querySelector(Selectors.cotizacion.cortinaInstalacion);
// Formulario Cotizado
const form_cotizado_cortina_tipo                  = document.querySelector(Selectors.formCotizado.cortinaTipo);
const form_cotizado_confeccion_tipo               = document.querySelector(Selectors.formCotizado.confeccionTipo);
const form_cotizado_ancho                         = document.querySelector(Selectors.formCotizado.ancho);
const form_cotizado_alto                          = document.querySelector(Selectors.formCotizado.alto);
const form_cotizado_tela_tipo                     = document.querySelector(Selectors.formCotizado.telaTipo);
const form_cotizado_tela_suboption                = document.querySelector(Selectors.formCotizado.telaSuboption);
const form_cotizado_tela_opcion_color             = document.querySelector(Selectors.formCotizado.telaOpcionColor);
const form_cotizado_accionamiento_tipo            = document.querySelector(Selectors.formCotizado.accionamientoTipo);
const form_cotizado_caida_sentido                 = document.querySelector(Selectors.formCotizado.caidaSentido);
const form_cotizado_cantidad_pano                 = document.querySelector(Selectors.formCotizado.cantidadPano);
const form_cotizado_tipo_cortina                  = document.querySelector(Selectors.formCotizado.cortinaTipo);
const form_cotizado_mando_posicion                = document.querySelector(Selectors.formCotizado.mandoPosicion);
const form_cotizado_color_accesorio               = document.querySelector(Selectors.formCotizado.colorAccesorio);
const form_cotizado_cortina_instalacion           = document.querySelector(Selectors.formCotizado.cortinaInstalacion);
const form_cotizado_instalacion                   = document.querySelector(Selectors.formCotizado.instalacion);
const form_cotizado_instalacion_region            = document.querySelector(Selectors.formCotizado.instalacionRegion);
const form_cotizado_instalacion_comuna            = document.querySelector(Selectors.formCotizado.instalacionComuna);
const form_cotizado_instalacion_direccion         = document.querySelector(Selectors.formCotizado.instalacionDireccion);
const form_cotizado_nombre                        = document.querySelector(Selectors.formCotizado.nombre);
const form_cotizado_mensaje                       = document.querySelector(Selectors.formCotizado.mensaje);
const form_cotizado_homologado_venta              = document.querySelector(Selectors.formCotizado.homologadoVenta);
// Hidden Form Productos
const hidden_form_producto_sujetador_cadena       = document.querySelector(Selectors.hiddenFormProductos.sujetadorCadena);
const hidden_form_producto_unidad_control         = document.querySelector(Selectors.hiddenFormProductos.unidadControl);
const hidden_form_producto_cadena                 = document.querySelector(Selectors.hiddenFormProductos.cadena);
const hidden_form_producto_cierre_cadena          = document.querySelector(Selectors.hiddenFormProductos.cierreCadena);
const hidden_form_producto_clip_tope              = document.querySelector(Selectors.hiddenFormProductos.clipTope);
const hidden_form_producto_terminal_riel_inferior = document.querySelector(Selectors.hiddenFormProductos.terminalRielInferior);
const hidden_form_producto_riel_inferior          = document.querySelector(Selectors.hiddenFormProductos.rielInferior);
const hidden_form_producto_tubo                   = document.querySelector(Selectors.hiddenFormProductos.tubo);
const hidden_form_producto_motor                  = document.querySelector(Selectors.hiddenFormProductos.motor);
const hidden_form_producto_motor_control          = document.querySelector(Selectors.hiddenFormProductos.motorControl);
const hidden_form_producto_tela_roller            = document.querySelector(Selectors.hiddenFormProductos.telaRoller);
const hidden_form_producto_zuncho                 = document.querySelector(Selectors.hiddenFormProductos.zuncho);
const hidden_form_producto_roller_plus            = document.querySelector(Selectors.hiddenFormProductos.rollerPlus);
const hidden_form_producto_confeccion             = document.querySelector(Selectors.hiddenFormProductos.confeccion);
const hidden_form_producto_instalacion            = document.querySelector(Selectors.hiddenFormProductos.instalacion);
const hidden_form_producto_peso_envio             = document.querySelector(Selectors.hiddenFormProductos.pesoEnvio);
const hidden_form_producto_homologado_venta       = document.querySelector(Selectors.hiddenFormProductos.homologadoVenta);
// Hidden Form Productos Duo
const hidden_form_producto_unidad_control_duo     = document.querySelector(Selectors.hiddenFormProductosDuo.unidadControl);
const hidden_form_producto_riel_cenefa_duo        = document.querySelector(Selectors.hiddenFormProductosDuo.rielCenefa);
const hidden_form_producto_bracket_duo            = document.querySelector(Selectors.hiddenFormProductosDuo.bracket);
const hidden_form_producto_riel_inferior_duo      = document.querySelector(Selectors.hiddenFormProductosDuo.rielInferior);
const hidden_form_producto_riel_tubo_inferior_duo = document.querySelector(Selectors.hiddenFormProductosDuo.rielTuboInferior);
const hidden_form_producto_set_terminal_duo       = document.querySelector(Selectors.hiddenFormProductosDuo.setTerminal);
const hidden_form_producto_sujetador_cadena_duo   = document.querySelector(Selectors.hiddenFormProductosDuo.sujetadorCadena);
const hidden_form_producto_tubo_duo               = document.querySelector(Selectors.hiddenFormProductosDuo.tubo);
const hidden_form_producto_cierre_cadena_duo      = document.querySelector(Selectors.hiddenFormProductosDuo.cierreCadena);
const hidden_form_producto_clip_tope_duo          = document.querySelector(Selectors.hiddenFormProductosDuo.clipTope);
const hidden_form_producto_cadena_duo             = document.querySelector(Selectors.hiddenFormProductosDuo.cadena);
const hidden_form_producto_motor_duo              = document.querySelector(Selectors.hiddenFormProductosDuo.motor);
const hidden_form_producto_motor_control_duo      = document.querySelector(Selectors.hiddenFormProductosDuo.motorControl);
const hidden_form_producto_tela_roller_duo        = document.querySelector(Selectors.hiddenFormProductosDuo.telaRoller);
const hidden_form_producto_confeccion_duo         = document.querySelector(Selectors.hiddenFormProductosDuo.confeccion);
const hidden_form_producto_instalacion_duo        = document.querySelector(Selectors.hiddenFormProductosDuo.instalacion);
const hidden_form_producto_peso_envio_duo         = document.querySelector(Selectors.hiddenFormProductosDuo.pesoEnvio);
const hidden_form_producto_homologado_venta_duo   = document.querySelector(Selectors.hiddenFormProductosDuo.homologadoVenta);
// Hidden Productos ?
let hidden_producto_sujetador_cadena              = document.querySelector(Selectors.hiddenProducto.sujetadorCadena);
let hidden_producto_unidad_control                = document.querySelectorAll(Selectors.hiddenProducto.unidadControl);
let hidden_producto_cadena                        = document.querySelectorAll(Selectors.hiddenProducto.cadena);
let hidden_producto_cierre_cadena                 = document.querySelectorAll(Selectors.hiddenProducto.cierreCadena);
let hidden_producto_clip_tope                     = document.querySelectorAll(Selectors.hiddenProducto.clipTope);
let hidden_producto_terminal_riel_inferior        = document.querySelectorAll(Selectors.hiddenProducto.terminalRielInferior);
let hidden_producto_riel_inferior                 = document.querySelector(Selectors.hiddenProducto.rielInferior);
let hidden_producto_tubo                          = document.querySelector(Selectors.hiddenProducto.tubo);
let hidden_producto_motor                         = document.querySelector(Selectors.hiddenProducto.motor);
let hidden_producto_motor_control                 = document.querySelector(Selectors.hiddenProducto.motorControl);
let hidden_producto_tela_roller                   = document.querySelectorAll(Selectors.hiddenProducto.telaRoller);
let hidden_producto_zuncho                        = document.querySelector(Selectors.hiddenProducto.zuncho);
let hidden_producto_roller_plus                   = document.querySelector(Selectors.hiddenProducto.rollerPlus);
let hidden_producto_confeccion                    = document.querySelector(Selectors.hiddenProducto.confeccion);
let hidden_producto_instalacion                   = document.querySelector(Selectors.hiddenProducto.instalacion);
// Hidden Productos Duo ?
let hidden_producto_unidad_control_duo            = document.querySelector(Selectors.hiddenProductoDuo.unidadControl);
let hidden_producto_riel_cenefa_duo               = document.querySelectorAll(Selectors.hiddenProductoDuo.rielCenefa);
let hidden_producto_bracket_duo                   = document.querySelector(Selectors.hiddenProductoDuo.bracket);
let hidden_producto_riel_inferior_duo             = document.querySelector(Selectors.hiddenProductoDuo.rielInferior);
let hidden_producto_riel_tubo_inferior_duo        = document.querySelector(Selectors.hiddenProductoDuo.rielTuboInferior);
let hidden_producto_set_terminal_duo              = document.querySelector(Selectors.hiddenProductoDuo.setTerminal);
let hidden_producto_sujetador_cadena_duo          = document.querySelector(Selectors.hiddenProductoDuo.sujetadorCadena);
let hidden_producto_tubo_duo                      = document.querySelector(Selectors.hiddenProductoDuo.tubo);
let hidden_producto_cierre_cadena_duo             = document.querySelectorAll(Selectors.hiddenProductoDuo.cierreCadena);
let hidden_producto_clip_tope_duo                 = document.querySelectorAll(Selectors.hiddenProductoDuo.clipTope);
let hidden_producto_cadena_duo                    = document.querySelectorAll(Selectors.hiddenProductoDuo.cadena);
let hidden_producto_tela_roller_duo               = document.querySelectorAll(Selectors.hiddenProductoDuo.telaRoller);
let hidden_producto_motor_duo                     = document.querySelector(Selectors.hiddenProductoDuo.motor);
let hidden_producto_motor_control_duo             = document.querySelector(Selectors.hiddenProductoDuo.motorControl);
let hidden_producto_confeccion_duo                = document.querySelector(Selectors.hiddenProductoDuo.confeccion);
let hidden_producto_instalacion_duo               = document.querySelector(Selectors.hiddenProductoDuo.instalacion);
// print cotización area
const hidden_cotizacion_area                      = document.querySelector(Selectors.printCotizacion.area);
const cotiza_container                            = document.querySelector(".cotiza-cortina");

async function initCotizadorBootstrapData() {
  if (typeof fetchCotizadorBootstrap !== "function") {
    console.error("No existe helper fetchCotizadorBootstrap");
    return;
  }

  const bootstrap = await fetchCotizadorBootstrap({ container: cotiza_container });
  if (bootstrap && typeof applyCotizadorBootstrapToDom === "function") {
    applyCotizadorBootstrapToDom(bootstrap);
  }
}

// Massive Event Listeners
function addEventListenerToCollection(collection, event, callback, ...args) {
  if (collection && collection.length > 0) {
    collection.forEach(item => {
      item.addEventListener(event, function(e) {
        callback.apply(this, [e, ...args]);
      });
    });
  }
}

// Acordeon
addEventListenerToCollection(cotiza_titles, "click", toggleTitle);
addEventListenerToCollection(cotiza_subtitles, "click", toggleSubtitle);
addEventListenerToCollection(label_radios, "click", activeLabelRadio);
addEventListenerToCollection(input_tela_suboptions, "click", activeTelaSuboption);

// Formulario
addEventListenerToCollection(input_cortina_tipos, "change", setCotizacion, "cortinaTipo");
addEventListenerToCollection(input_confeccion_tipos, "change", setCotizacion, "confeccionTipo");
addEventListenerToCollection(input_tela_tipos, "click", setCotizacion, "telaTipo");
addEventListenerToCollection(input_tela_tipos, "change", setCotizacion, "telaTipo");
addEventListenerToCollection(input_tela_suboptions, "change", setCotizacion, "telaSuboption");
addEventListenerToCollection(input_tela_opcion_colores, "change", setCotizacion, "telaOptionColor");
addEventListenerToCollection(input_tipo_cortinas, "change", setCotizacion, "tipoCortina");
addEventListenerToCollection(input_accionamiento_tipos, "change", setCotizacion, "accionamientoTipo");
addEventListenerToCollection(input_caida_sentidos, "change", setCotizacion, "caidaSentido");
addEventListenerToCollection(input_mando_posiciones, "change", setCotizacion, "posicionMando");
addEventListenerToCollection(input_color_accesorios, "change", setCotizacion, "colorAccesorio");
addEventListenerToCollection(input_cortina_instalaciones, "change", setCotizacion, "instalacionCortina");
addEventListenerToCollection(input_instalacion_tipos, "change", setCotizacion, "instalacionTipo");

// Eventos individuales
button_submit.addEventListener("click", submitCotizacion);
reset_button.addEventListener("click", resetForm);
region_select.addEventListener("change", setRegion);
window.addEventListener("load", loadBase);

// Eventos con multiples listeners
input_ancho.addEventListener("change", setCotizacionAncho);
input_ancho.addEventListener("blur", setCotizacionAncho);
input_alto.addEventListener("change", setCotizacionAlto);
input_alto.addEventListener("blur", setCotizacionAlto);

input_control_motor.addEventListener("change", setCotizacionMotorControl);

input_instalacion_direccion.addEventListener("change", setCotizacionInstalacionDireccion);
input_instalacion_direccion.addEventListener("input", setCotizacionInstalacionDireccion);

input_instalacion_region.addEventListener("change", setCotizacionInstalacionRegion);
input_instalacion_comuna.addEventListener("change", setCotizacionInstalacionComuna);
input_nombre.addEventListener("change", setCotizacionNombre);
input_mensaje.addEventListener("change", setCotizacionMensaje);

// Acordeon
function toggleTitle(event) {
  const cotizaContent = this.nextElementSibling;
  const parent = this.parentNode;
  const isActive = parent.classList.contains("active");

  closeAllTitles(this);

  // Toggle el estado activo del título y del contenedor padre
  this.classList.toggle("active");
  parent.classList.toggle("active", !isActive);

  // Configurar la altura máxima dependiendo del estado actual
  cotizaContent.style.maxHeight = isActive ? null : `${cotizaContent.scrollHeight}px`;
}

function openTitle(object) {
  const cotizaContent = object.nextElementSibling;

  // Añade la clase "active" al título y a su contenedor padre
  object.classList.add("active");
  object.parentNode.classList.add("active");

  // Establece la altura máxima del contenido
  cotizaContent.style.maxHeight = `${cotizaContent.scrollHeight}px`;
}

function triggerRadioMotor() {
  // Selecciona el elemento de radio
  const radioElement = document.querySelector('.accionamiento-tipo[data-value=motorizado]');

  // Verifica si el elemento existe
  if (radioElement) {
      // Marca el radio como seleccionado
      radioElement.checked = true;

      // Crea un nuevo evento de cambio
      var event = new Event('change', {
          'bubbles': true,
          'cancelable': true
      });

      // Despacha el evento de cambio
      radioElement.dispatchEvent(event);
  }
}

function openAllTitles() {
  cotiza_titles.forEach(title => openTitle(title));
}

function closeTitle(object) {
  const cotiza_content = object.nextElementSibling;

  // Desactivar elemento y su contenedor padre en una sola línea usando chaining
  object.classList.remove("active");
  object.parentNode.classList.remove("active");

  cotiza_content.style.maxHeight = null;
}

function closeAllTitles($_this) {
  cotiza_titles.forEach(object => {
    // Si no se define $_this o si el número de opción no coincide, ejecutamos el código
    if (!$_this || object.dataset.optionNumber !== $_this.dataset.optionNumber) {
      const cotiza_content = object.nextElementSibling;
      object.parentNode.classList.remove("active");
      object.classList.remove("active");
      cotiza_content.style.maxHeight = null;
    }
  });
}

function toggleSubtitle(event) {
  const cotiza_option = this.nextElementSibling;

  const isActive = this.classList.contains("active");

  this.classList.toggle("active");
  this.parentNode.classList.toggle("active");

  cotiza_option.style.maxHeight = isActive ? null : cotiza_option.scrollHeight + "px";
}


function openSubtitle(object) {
  const cotiza_option = object.nextElementSibling;
  object.classList.add("active");
  cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
}

function openAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    const cotiza_option = object.nextElementSibling;
    object.classList.add("active");
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  });
}

function closeSubtitle(object) {
  const cotiza_option = object.nextElementSibling;
  object.classList.remove("active");
  cotiza_option.style.maxHeight = null;
}

function closeAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    const cotiza_option = object.nextElementSibling;
    object.classList.remove("active");
    cotiza_option.style.maxHeight = null;
  });
}

function getClosestParentWithClass(node, className) {
  let currentNode = node;
  while (currentNode) {
    if (currentNode.classList && currentNode.classList.contains(className)) {
      return currentNode;
    }
    currentNode = currentNode.parentNode;
  }
  return null;
}

function activateParentAndChildren(node) {
  turnOffRadios();
  node.classList.add("active");
  turnOffSuboptions();
  getClosestParentWithClass(node, "active").classList.add("active");
}

function activeLabelRadio(event) {
  let actionNode;

  switch(this.nodeName) {
    case 'IMG':
      actionNode = this.parentNode;
      break;
    case 'LABEL':
      actionNode = this;
      break;
    case 'SPAN':
      actionNode = this.parentNode;
      document.getElementById("screen_plus").setAttribute("checked", "checked");
      break;
    default:
      return;
  }

  if (getClosestParentWithClass(actionNode, "active")) {
    activateParentAndChildren(actionNode);
  }
}

function activeTelaSuboption(event) {
  turnOffSuboptions();
  turnOffRadios();
  this.parentNode.parentNode.parentNode.classList.add("active");

  // Buscar el primer elemento .label-colores que no esté oculto
  const activeLabel = Array.from(document.querySelectorAll(".suboptions.active .label-colores"))
    .find(label_radio => window.getComputedStyle(label_radio).display !== "none");

  // Si encontramos uno, lo marcamos y también marcamos su elemento hermano anterior
  if (activeLabel) {
    activeLabel.classList.add("active");
    let previousElement = activeLabel.previousElementSibling;
    previousElement.checked = true;
    previousElement.dispatchEvent(new Event('change'));
  }
}

function turnOffRadios() {
  document.querySelectorAll(".label-colores").forEach(el => el.classList.remove("active"));
}

function turnOffSuboptions() {
  document.querySelectorAll(Selectors.form.telaSuboptions).forEach(el => el.closest('.suboptions').classList.remove("active"));
}

function syncFormStock() {
  const tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;

  const configurations = {
    'roller': {
      baseSelector: '.normal-products',
      productSelectors: [
        '.product-unidad-control',
        '.product-cadena',
        '.product-cierre-cadena',
        '.product-clip-tope',
        '.product-terminal-riel-inferior',
        '.product-riel-inferior'
      ]
    },
    'roller-duo': {
      baseSelector: '.duo-products',
      productSelectors: [
        '.product-unidad-control-duo',
        '.product-riel-cenefa-duo',
        '.product-cierre-cadena-duo',
        '.product-clip-tope-duo',
        '.product-cadena-duo'
      ]
    }
  };

  const config = configurations[tipo_cortina];
  if (config) {
    const accessoryColors = Array.from(input_color_accesorios).map(input => input.dataset.value).filter(Boolean);

    const selectorHasColorVariants = selector => {
      return Array.from(document.querySelectorAll(`${config.baseSelector} ${selector}`)).some(product => {
        return product.dataset && accessoryColors.includes(product.dataset.productColor);
      });
    };

    input_color_accesorios.forEach(input_color_accesorio => {
      input_color_accesorio.classList.remove("hide");
      input_color_accesorio.nextElementSibling.classList.remove("hide");

      for (const selector of config.productSelectors) {
        if (selectorHasColorVariants(selector) && document.querySelectorAll(`${config.baseSelector} ${selector}[data-product-color='${input_color_accesorio.dataset.value}']`).length === 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
          break;  // Break out once we find a non-matching selector
        }
      }
    });
  }

  setTelaHeight();
}

// Refactor repetitive code into a function
function hideElements(selectorArray) {
  selectorArray.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      element.parentNode.classList.add("not-show");
    }
  });
}

function showElements(selectorArray) {
  selectorArray.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      element.parentNode.classList.remove("not-show");
    }
  });
}

// Onload
async function loadBase() {
  await initCotizadorBootstrapData();
  hydrateBootstrapRollerComponents();
  refreshHiddenProductoRollerRefs();
  const reset_form = findGetParameter("reset_form");
  const tipo_cotizador = document.querySelector(".cotiza51").dataset.cotizador;
  const cotiza_content = document.querySelector(".cotiza-cortina .content");

  // Consolidate conditions
  if (reset_form === "true") {
    const { top } = document.querySelector(".cortina-type").getBoundingClientRect();
    const header_height = document.querySelector("#shopify-section-header header").offsetHeight;

    window.scrollBy({
      top: top - header_height,
      left: 0,
      behavior: 'smooth'
    });

    window.history.replaceState({}, document.title, new URL(document.URL).pathname);
  }

  cotiza_content.style.maxHeight = cotiza_content.style.maxHeight ? null : `${cotiza_content.scrollHeight}px`;

  if (tipo_cotizador === "roller") {
    hideElements([".val-tipo-cortina", ".val-cantidad-pano"]);
    if (form_cotizado_cortina_tipo.value === 'roller-duo') {
      hideElements([".val-confeccion-tipo"]);
    }
  }

  loadCortinas();

  setValue("cortinaTipo", input_cortina_tipos[0].value); // Tipo Cortina
  setFormCotizadoCortinaTipo(input_cortina_tipos[0]); // Tipo Cortina
  setValue("confeccionTipo", input_confeccion_tipos[0].value); // Revisar esto
  setFormCotizadoConfeccionTipo(input_confeccion_tipos[0]);
  setValue("ancho", `${input_ancho.value} cm`);
  setFormCotizadoAncho(input_ancho.value);
  setValue("alto", `${input_alto.value} cm`);
  setFormCotizadoAlto(input_alto.value);
  setValue("telaTipo", input_tela_tipos[0].value); // Tipo Tela
  setFormCotizadoTelaTipo(input_tela_tipos[0]); // Tipo Tela
  setValue("telaSuboption", input_tela_suboptions[0].value); // Suboption Tela
  setFormCotizadoTelaSuboption(input_tela_suboptions[0]); // Suboption Tela
  setValue("instalacionCortina", input_cortina_instalaciones[0].value);
  setFormCotizadoInstalacionCortina(input_cortina_instalaciones[0]);
  setValue("instalacionTipo", input_instalacion_tipos[0].value);
  setFormCotizadoInstalacionTipo(input_instalacion_tipos[0]);
  setFormCotizadoInstalacionRegion(input_instalacion_region[6]);
  setFormCotizadoInstalacionComuna(input_instalacion_direccion[47]);
  setFormCotizadoNombre(input_nombre.value);
  setFormCotizadoMensaje(input_mensaje.value);

  if (tipo_cotizador === "roller") {
    setValue("accionamientoTipo", input_accionamiento_tipos[0].value);
    setFormCotizadoAccionamientoTipo(input_accionamiento_tipos[0]);
    setValue("colorAccesorio", input_color_accesorios[0].value);
    setFormCotizadoColorAccesorio(input_color_accesorios[0]);
    setValue("posicionMando", input_mando_posiciones[0].value);
    setFormCotizadoPosicionMando(input_mando_posiciones[0]);
    setValue("caidaSentido", input_caida_sentidos[0].value);
    setFormCotizadoCaidaSentido(input_caida_sentidos[0]);
  }

  checkFormCotizacion();
  setForm();
}

function setRegion() {
  if (region_select.value !== '1') {
    radio_message_container.classList.add("show");
    radio_container.classList.remove("show");
    address_container.classList.remove("show");
    input_instalacion_tipos[1].checked = true;
    input_instalacion_tipos[1].dispatchEvent(new Event('change'));
  } else {
    radio_message_container.classList.remove("show");
    radio_container.classList.add("show");
    address_container.classList.add("show");
    input_instalacion_tipos[0].checked = true;
    input_instalacion_tipos[0].dispatchEvent(new Event('change'));
  }
}

function toggleCotizaContentMaxHeight() {
  let cotiza_content = document.querySelector(".cotiza-cortina .content");
  cotiza_content.style.maxHeight = cotiza_content.style.maxHeight ? null : cotiza_content.scrollHeight + "px";
}

function resetInputValues() {
  setInputValue(input_cortina_tipos, 0);
  setInputValue(input_ancho, "40");
  setInputValue(input_alto, "40");
  setInputValue(input_tela_tipos, indexInParent(getCurrentRadioWrap()));
  setInputValue(input_accionamiento_tipos, 0);
  setInputValue(input_caida_sentidos, 0);
  setInputValue(input_color_accesorios, indexInParent(getCurrentColorAccesorio()));
  setInputValue(input_mando_posiciones, 0);
  setInputValue(input_cortina_instalaciones, 0);
  setInputValue(input_nombre, "");
  setInputValue(input_mensaje, "");
}

function scrollToCortinaType() {
  let top_element = document.querySelector(".cortina-type").getBoundingClientRect().top;
  let header = document.querySelector("#shopify-section-header header");
  window.scrollBy({
    top: top_element - header.offsetHeight,
    left: 0,
    behavior: 'smooth'
  });
}

// Click Reset
function resetForm() {
  toggleCotizaContentMaxHeight();
  resetInputValues();
  closeAllSubtitles();
  closeAllTitles();
  openTitle(document.querySelector(".title-select-h1[data-option-number='1']"));
  scrollToCortinaType();
}

function checkFormCotizacion() {
  syncFormStock();

  const COTIZA_SELECTOR = `.cotiza-cortina[data-cortina-${form_cotizado_cortina_tipo.value}="true"]`;
  const COTIZA_SELECTOR_FALSE = `.cotiza-cortina[data-cortina-${form_cotizado_cortina_tipo.value}="false"]`;
  let cotiza_active_blocks = document.querySelectorAll(COTIZA_SELECTOR);
  let cotiza_unactive_blocks = document.querySelectorAll(COTIZA_SELECTOR_FALSE);

  if (form_cotizado_cortina_tipo.value == 'roller') {
    showElements([".val-confeccion-tipo"]);
  } else {
    hideElements([".val-confeccion-tipo"]);
  }

  // Bloques
  if (cotiza_unactive_blocks.length > 0) {
    turnOffCotizaParentParentBlocks(cotiza_unactive_blocks);
  }
  if (cotiza_active_blocks.length > 0) {
    turnOnCotizaParentParentBlocks(cotiza_active_blocks);
  }

  // Tela Tipo
  turnOffAllTelaTipoBlocks(input_tela_tipos);
  turnOnStockTelaTipoBlocks();
}

function turnOnStockTelaTipoBlocks(cotiza_tela_tipo_blocks) {
  const telaTipoBlocks = cotiza_tela_tipo_blocks || document.querySelectorAll(Selectors.form.telaTipos);
  const tipo_cortina = form_cotizado_cortina_tipo.value;
  const colores = document.querySelectorAll(".tela-opcion-colores");
  const opciones = document.querySelectorAll(".tela-suboptions");
  const productSelectorBase = {
    'roller': '.normal-products .product-tela-roller',
    'roller-duo': '.duo-products .product-tela-roller-duo'
  };

  telaTipoBlocks.forEach(cotiza_tela_tipo_block => {
    const tela = cotiza_tela_tipo_block.dataset.value;
    const baseSelector = `${productSelectorBase[tipo_cortina]}[data-product-tela='${tela}']`;
    if (document.querySelectorAll(baseSelector).length > 0) {
      cotiza_tela_tipo_block.parentNode.classList.add("show");
    }

    opciones.forEach(options => {
      const tipo = options.dataset.value;
      const typeSelector = `${baseSelector}[data-product-tipo='${tipo}']`;
      if (tipo_cortina === 'roller' && tela === 'screen' && document.querySelectorAll(typeSelector).length > 0) {
        options.parentNode.parentNode.parentNode.classList.remove("hide");
        cotiza_tela_tipo_block.parentNode.classList.add("show");
      }

      colores.forEach(colors => {
        const color = colors.dataset.value;
        if (!color) return;
        let selector = `${productSelectorBase[tipo_cortina]}[data-product-tela='${tela}'][data-product-color='${color}']`;

        // Adjust selector based on special conditions
        if (tipo_cortina === 'roller' && tela === 'screen') {
          selector += `[data-product-tipo='${tipo}']`;
        }

        // Check product length
        const length_products = document.querySelectorAll(selector).length;
        if (length_products > 0) {
          options.parentNode.parentNode.parentNode.classList.remove("hide");
          cotiza_tela_tipo_block.parentNode.classList.add("show");
        }
      });
    });
  });

  const eClick = new Event('click');
  const eChange = new Event('change');
  const radio_wrap = document.querySelector(".radios .radio-wrap.show .tela-tipos");
  if (radio_wrap) {
    radio_wrap.checked = true;
    radio_wrap.dispatchEvent(eClick);
    radio_wrap.dispatchEvent(eChange);
  }
}

function turnOffAllTelaTipoBlocks() {
  const activeBlocks = document.querySelectorAll('.radios .radio-wrap.show');
  activeBlocks.forEach(block => block.classList.remove("show"));
}

function turnOffCotizaParentParentBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(block => {
    block.parentNode.parentNode.classList.remove("show");
  });
}

function turnOnCotizaParentParentBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(block => {
    if ((block.dataset.cortinaRoller === 'true' && form_cotizado_cortina_tipo.value === 'roller') || (block.dataset.cortinaRollerDuo === 'true' && form_cotizado_cortina_tipo.value === 'roller-duo'))
      block.parentNode.parentNode.classList.add("show");
    else
      block.parentNode.parentNode.classList.remove("show");
  });

  const activeTitle = document.querySelector(".option.active .title-select-h1");
  const defaultTitle = document.querySelector(".option .title-select-h1");
  openTitle(activeTitle || defaultTitle);
}

function turnOffAllCotizaBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(block => block.classList.remove("show"));
}

function checkCotizaSinStock(params) {
  // Implementar en algún momento esta validación para mostrar un mensaje de sin stock
  return true;
}

function handleMotorSetup(motorVar, setHiddenFunction) {
  const motorSelector = "input[name=accionamiento-tipos][data-value=motorizado]";
  if (motorVar) {
    setHiddenFunction({"input": motorVar});
  } else {
    document.querySelector(motorSelector).disabled = true;
  }
}


function processRoller() {
  setHiddenFormProductoSujetadorCadena({"input": hidden_producto_sujetador_cadena, "value": hidden_producto_sujetador_cadena.value});
  setHiddenFormProductoUnidadControl({"input": getHiddenProductoUnidadControl()}); // Color Accesorio
  setHiddenFormProductoCierreCadena({"input": getHiddenProductoCierreCadena()}); // Color Accesorio
  setHiddenFormProductoClipTope({"input": getHiddenProductoClipTope()}); // Color Accesorio
  if (hidden_producto_motor !== null) {
    setHiddenFormProductoMotor({"input": hidden_producto_motor});
    setHiddenFormProductoMotorControl({"input": hidden_producto_motor_control});
    document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = false;
  } else {
    document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = true
  }
  setHiddenFormProductoTerminalRielInferior({"input": getHiddenProductoTerminalRielInferior()}); // Color Accesorio
  calculateCadena({"input": getHiddenProductoCadena()}); // Color Accesorio
  calculateRielInferior({"input": getHiddenProductoRielInferior()}); // Color Accesorio
  calculateTubo({"input": hidden_producto_tubo, "value": hidden_producto_tubo.value});
  calculateZuncho({"input": hidden_producto_zuncho, "value": hidden_producto_zuncho.value});
  calculatePlus({"input": hidden_producto_roller_plus, "value": hidden_producto_roller_plus ? hidden_producto_roller_plus.value : 0});
  calculateTelaRoller({"input": getHiddenProductoTelaRoller()}); // Color-Tipo Tela
  calculateTotalWeight({"sujetador": hidden_producto_sujetador_cadena, "unidad_control": getHiddenProductoUnidadControl(), "cierre_cadena": getHiddenProductoCierreCadena(), "clip_tope": getHiddenProductoClipTope(), "motor": hidden_producto_motor, "terminal": getHiddenProductoTerminalRielInferior(), "cadena": getHiddenProductoCadena(), "riel": getHiddenProductoRielInferior(), "tubo": hidden_producto_tubo, "zuncho": hidden_producto_zuncho, "tela": getHiddenProductoTelaRoller()});
  calculateConfeccion({"input": hidden_producto_confeccion});
}

function processRollerDuo() {
  setHiddenFormProductoUnidadControlDuo({"input": hidden_producto_unidad_control_duo, "value": hidden_producto_unidad_control_duo.value});
  setHiddenFormProductoSetTerminalDuo({"input": hidden_producto_set_terminal_duo, "value": hidden_producto_set_terminal_duo.value});
  setHiddenFormProductoSujetadorCadenaDuo({"input": hidden_producto_sujetador_cadena_duo, "value": hidden_producto_sujetador_cadena_duo.value});
  setHiddenFormProductoCierreCadenaDuo({"input": getHiddenProductoCierreCadenaDuo()});
  setHiddenFormProductoClipTopeDuo({"input": getHiddenProductoClipTopeDuo()});
  if (hidden_producto_motor_duo !== null) {
    setHiddenFormProductoMotorDuo({"input": hidden_producto_motor_duo});
    setHiddenFormProductoMotorControlDuo({"input": hidden_producto_motor_control_duo});
  } else {
    document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = true
  }
  calculateRielCenefaDuo({"input": getHiddenProductoRielCenefaDuo()});
  calculateBracketDuo({"input": hidden_producto_bracket_duo, "value": hidden_producto_bracket_duo.value});
  calculateRielInferiorDuo({"input": hidden_producto_riel_inferior_duo, "value": hidden_producto_riel_inferior_duo.value});
  calculateRielTuboInferiorDuo({"input": hidden_producto_riel_tubo_inferior_duo, "value": hidden_producto_riel_tubo_inferior_duo.value});
  calculateTuboDuo({"input": hidden_producto_tubo_duo, "value": hidden_producto_tubo_duo.value});
  calculateCadenaDuo({"input": getHiddenProductoCadenaDuo()});
  calculatePlusDuo({"input": hidden_producto_roller_plus, "value": hidden_producto_roller_plus ? hidden_producto_roller_plus.value : 0});
  calculateTelaRollerDuo({"input": getHiddenProductoTelaRollerDuo()});
  calculateTotalWeightDuo({"unidad_control": hidden_producto_unidad_control_duo, "set_terminal": hidden_producto_set_terminal_duo, "sujetador_cadena": hidden_producto_sujetador_cadena_duo, "cierre_cadena": getHiddenProductoCierreCadenaDuo(), "clip_tope": getHiddenProductoClipTopeDuo(), "motor": hidden_producto_motor_duo, "riel_cenefa": getHiddenProductoRielCenefaDuo(), "bracket": hidden_producto_bracket_duo, "riel_inferior": hidden_producto_riel_inferior_duo, "riel_tubo_inferior": hidden_producto_riel_tubo_inferior_duo, "tubo": hidden_producto_tubo_duo, "cadena": getHiddenProductoCadenaDuo(), "tela": getHiddenProductoTelaRollerDuo()});
  calculateConfeccionDuo({"input": hidden_producto_confeccion_duo});
}

function setMotor(motorVar, selector) {
  if (motorVar !== null) {
    setHiddenFormProductoMotor({"input": motorVar});
  } else {
    document.querySelector(selector).disabled = true;
  }
}

function setForm() {
  let response = true;
  if (checkCotizaSinStock()) {
    let tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
    switch (tipo_cortina) {
      case 'roller':
        setHiddenFormProductoSujetadorCadena({"input": hidden_producto_sujetador_cadena, "value": hidden_producto_sujetador_cadena.value});
        setHiddenFormProductoUnidadControl({"input": getHiddenProductoUnidadControl()}); // Color Accesorio
        setHiddenFormProductoCierreCadena({"input": getHiddenProductoCierreCadena()}); // Color Accesorio
        setHiddenFormProductoClipTope({"input": getHiddenProductoClipTope()}); // Color Accesorio
        if (hidden_producto_motor !== null) {
          setHiddenFormProductoMotor({"input": hidden_producto_motor});
          setHiddenFormProductoMotorControl({"input": hidden_producto_motor_control});
          document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = false;
        } else {
          document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = true
        }
        setHiddenFormProductoTerminalRielInferior({"input": getHiddenProductoTerminalRielInferior()}); // Color Accesorio
        calculateCadena({"input": getHiddenProductoCadena()}); // Color Accesorio
        calculateRielInferior({"input": getHiddenProductoRielInferior()}); // Color Accesorio
        calculateTubo({"input": hidden_producto_tubo, "value": hidden_producto_tubo.value});
        calculateZuncho({"input": hidden_producto_zuncho, "value": hidden_producto_zuncho.value});
        calculatePlus({"input": hidden_producto_roller_plus, "value": hidden_producto_roller_plus ? hidden_producto_roller_plus.value : 0});
        calculateTelaRoller({"input": getHiddenProductoTelaRoller()}); // Color-Tipo Tela
        calculateTotalWeight({"sujetador": hidden_producto_sujetador_cadena, "unidad_control": getHiddenProductoUnidadControl(), "cierre_cadena": getHiddenProductoCierreCadena(), "clip_tope": getHiddenProductoClipTope(), "motor": hidden_producto_motor, "terminal": getHiddenProductoTerminalRielInferior(), "cadena": getHiddenProductoCadena(), "riel": getHiddenProductoRielInferior(), "tubo": hidden_producto_tubo, "zuncho": hidden_producto_zuncho, "tela": getHiddenProductoTelaRoller()});
        calculateConfeccion({"input": hidden_producto_confeccion});
        break;
      case 'roller-duo':
        // Duos
        setHiddenFormProductoUnidadControlDuo({"input": hidden_producto_unidad_control_duo, "value": hidden_producto_unidad_control_duo.value});
        setHiddenFormProductoSetTerminalDuo({"input": hidden_producto_set_terminal_duo, "value": hidden_producto_set_terminal_duo.value});
        setHiddenFormProductoSujetadorCadenaDuo({"input": hidden_producto_sujetador_cadena_duo, "value": hidden_producto_sujetador_cadena_duo.value});
        setHiddenFormProductoCierreCadenaDuo({"input": getHiddenProductoCierreCadenaDuo()});
        setHiddenFormProductoClipTopeDuo({"input": getHiddenProductoClipTopeDuo()});
        if (hidden_producto_motor_duo !== null) {
          setHiddenFormProductoMotorDuo({"input": hidden_producto_motor_duo});
          setHiddenFormProductoMotorControlDuo({"input": hidden_producto_motor_control_duo});
        } else {
          document.querySelector("input[name=accionamiento-tipos][data-value=motorizado]").disabled = true
        }
        calculateRielCenefaDuo({"input": getHiddenProductoRielCenefaDuo()});
        calculateBracketDuo({"input": hidden_producto_bracket_duo, "value": hidden_producto_bracket_duo.value});
        calculateRielInferiorDuo({"input": hidden_producto_riel_inferior_duo, "value": hidden_producto_riel_inferior_duo.value});
        calculateRielTuboInferiorDuo({"input": hidden_producto_riel_tubo_inferior_duo, "value": hidden_producto_riel_tubo_inferior_duo.value});
        calculateTuboDuo({"input": hidden_producto_tubo_duo, "value": hidden_producto_tubo_duo.value});
        calculateCadenaDuo({"input": getHiddenProductoCadenaDuo()});
        calculatePlusDuo({"input": hidden_producto_roller_plus, "value": hidden_producto_roller_plus ? hidden_producto_roller_plus.value : 0});
        calculateTelaRollerDuo({"input": getHiddenProductoTelaRollerDuo()});
        calculateTotalWeightDuo({"unidad_control": hidden_producto_unidad_control_duo, "set_terminal": hidden_producto_set_terminal_duo, "sujetador_cadena": hidden_producto_sujetador_cadena_duo, "cierre_cadena": getHiddenProductoCierreCadenaDuo(), "clip_tope": getHiddenProductoClipTopeDuo(), "motor": hidden_producto_motor_duo, "riel_cenefa": getHiddenProductoRielCenefaDuo(), "bracket": hidden_producto_bracket_duo, "riel_inferior": hidden_producto_riel_inferior_duo, "riel_tubo_inferior": hidden_producto_riel_tubo_inferior_duo, "tubo": hidden_producto_tubo_duo, "cadena": getHiddenProductoCadenaDuo(), "tela": getHiddenProductoTelaRollerDuo()});
        calculateConfeccionDuo({"input": hidden_producto_confeccion_duo});
        break;
    }
    setHiddenFormProductoInstalacion({"value": form_cotizado_instalacion.value});
    setHiddenFormProductoInstalacionDuo({"value": form_cotizado_instalacion.value});

    calculaCotizacion();
  } else {
    response = false;
  }
  return response;
}

// Set Cotizador Input
function setInputValue(element, value) {
  if (element instanceof HTMLInputElement && element.type === "radio") {
    element[value].checked = true;
  } else {
    element.value = value;
  }
  element.dispatchEvent(new Event('change'));
}

function getCotizadorProductDataset(product) {
  return product && product.dataset ? product.dataset : {};
}

function getCotizadorProductValue(product) {
  return product && Number.isFinite(Number(product.value)) ? Number(product.value) : 0;
}

function cotizadorProductHasClass(product, className) {
  if (!product || !className) return false;
  if (product.classList && typeof product.classList.contains === "function") {
    return product.classList.contains(className);
  }
  return product.className === className;
}

function getRollerTelaProductsFromStore() {
  if (typeof findCotizadorProductGroup === "function") {
    const normalProducts = findCotizadorProductGroup("normalProducts", {
      productKey: "roller",
      containerClass: "normal-products",
      className: "product-tela-roller"
    });
    const duoProducts = findCotizadorProductGroup("duoProducts", {
      productKey: "roller",
      containerClass: "duo-products",
      className: "product-tela-roller-duo"
    });
    const groupedProducts = normalProducts.concat(duoProducts);
    if (groupedProducts.length > 0) return groupedProducts;
  }

  if (typeof findCotizadorProducts !== "function") return [];

  return findCotizadorProducts({ productKey: "roller" })
    .filter(product => product.className === "product-tela-roller" || product.className === "product-tela-roller-duo");
}

function findRollerTelaProductsFromStore(filters) {
  const products = getRollerTelaProductsFromStore();
  return products.filter(product => {
    const dataset = getCotizadorProductDataset(product);
    return Object.keys(filters).every(key => !filters[key] || dataset[key] === filters[key]);
  });
}

function generateHTMLTemplate(input, index, telaType) {
  const dataset = getCotizadorProductDataset(input);
  const productColor = dataset.productColor || `sku-${dataset.productSku || index}`;
  const productColorFull = dataset.productColorFull || dataset.productTitle || dataset.descripcionSoftland || productColor;
  const productImageTiny = dataset.productImageTiny || "";
  const productTitle = dataset.productTitle || productColorFull;

  return `
    <input type="radio" class="radio tela-opcion-colores tela-opcion-color-${telaType}" id="tela_opcion_colores_${index}" name="tela-opcion-colores" data-value="${productColor}" data-sku-softland="${dataset.skuSoftland}" data-sku="${dataset.productSku}" value="${productColorFull}">
    <label class="label-colores label-colores-${telaType}" for="tela_opcion_colores_${index}">
      <img src="${productImageTiny}" alt="${productTitle}" srcset="${productImageTiny}" width="29" height="29" loading="lazy">
      <span class="span-color">${productColorFull}</span>
    </label>`;
}

function handleizeCotizadorValue(value) {
  return (value || "")
    .toString()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getCotizadorBootstrapPayload() {
  return window.cotizadorBootstrapState && window.cotizadorBootstrapState.data ? window.cotizadorBootstrapState.data : null;
}

function getCotizadorBootstrapStockBySku(bootstrap) {
  const stock = bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [];
  return new Map(stock.map(item => [(item.sku || "").toString().trim().toUpperCase(), item]));
}

function setBootstrapDatasetValue(input, key, value, transform) {
  if (value === undefined || value === null || value === "") return;
  input.dataset[key] = transform ? transform(value) : value.toString();
}

function applyBootstrapImagesToTelaInput(input, images) {
  const primary = images && images.primary ? images.primary : null;
  const secondary = images && images.secondary ? images.secondary : primary;
  const fallback = input.dataset.productImageTiny || "";

  setBootstrapDatasetValue(input, "productImage", secondary && secondary.previewUrl ? secondary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageZoom", secondary && secondary.zoomUrl ? secondary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtra", primary && primary.previewUrl ? primary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtraZoom", primary && primary.zoomUrl ? primary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageTiny", primary && primary.tinyUrl ? primary.tinyUrl : fallback);
}

function upsertBootstrapTelaProduct(item, stockBySku) {
  const sku = (item.sku || "").toString().trim();
  const tela = handleizeCotizadorValue(item.categoria);
  const tipo = handleizeCotizadorValue(item.subtipo);
  const color = handleizeCotizadorValue(item.color);
  const isDuo = tela === "duo" || handleizeCotizadorValue(item.tipo) === "duo";
  const container = document.querySelector(isDuo ? ".duo-products" : ".normal-products");
  const productClass = isDuo ? "product-tela-roller-duo" : "product-tela-roller";

  if (!sku || !tela || !color || !container) return null;

  let input = container.querySelector(`.${productClass}[data-product-sku='${sku}'][data-product-color='${color}']`);
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-${productClass}-${sku}`;
    input.className = productClass;
    input.dataset.bootstrapCatalog = "true";
    container.appendChild(input);
  }

  const stock = stockBySku.get(sku.toUpperCase());
  const price = stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : Number(item.price || 0);
  const quantity = stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(item.inventoryQuantity || 0);

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "productTela", tela);
  setBootstrapDatasetValue(input, "productTipo", tipo);
  setBootstrapDatasetValue(input, "productColor", color);
  setBootstrapDatasetValue(input, "productColorFull", item.colorFull || item.color);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland);
  setBootstrapDatasetValue(input, "descripcionSoftland", (stock && stock.description) || item.descripcionSoftland || item.name);
  setBootstrapDatasetValue(input, "productWeight", item.weight || 0);
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || "g");
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", quantity > 0 ? "true" : "false");
  applyBootstrapImagesToTelaInput(input, item.images);

  return input;
}

function hydrateBootstrapTelaProducts() {
  const bootstrap = getCotizadorBootstrapPayload();
  const catalog = bootstrap && Array.isArray(bootstrap.catalog) ? bootstrap.catalog : [];
  if (catalog.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return catalog
    .map(item => upsertBootstrapTelaProduct(item, stockBySku))
    .filter(Boolean);
}

function getBootstrapSoftlandSku(softland) {
  if (!softland) return "";
  return (softland.codRapido || softland.codBarra || "").toString().trim();
}

function normalizeComponentKey(value) {
  return (value || "")
    .toString()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
}

function handleizeCotizadorComponentKey(value) {
  return normalizeComponentKey(value).replace(/_/g, "-");
}

const rollerComponentClassByKey = {
  sujetador_cadena: "product-sujetador-cadena",
  unidad_control: "product-unidad-control",
  cadena: "product-cadena",
  cierre_cadena: "product-cierre-cadena",
  clip_tope: "product-clip-tope",
  terminal_riel_inferior: "product-terminal-riel-inferior",
  riel_inferior: "product-riel-inferior",
  tubo: "product-tubo",
  motor: "product-motor",
  motor_control: "product-motor-control",
  zuncho: "product-zuncho",
  cenefa_extra: "product-cenefa-extra",
  roller_plus: "product-cenefa-extra",
  plus: "product-cenefa-extra",
  confeccion: "product-confeccion",
  instalacion: "product-instalacion",
  unidad_control_duo: "product-unidad-control-duo",
  riel_cenefa_duo: "product-riel-cenefa-duo",
  bracket_duo: "product-bracket-duo",
  riel_inferior_duo: "product-riel-inferior-duo",
  riel_tubo_inferior_duo: "product-riel-tubo-inferior-duo",
  set_terminal_duo: "product-set-terminal-duo",
  sujetador_cadena_duo: "product-sujetador-cadena-duo",
  tubo_duo: "product-tubo-duo",
  cierre_cadena_duo: "product-cierre-cadena-duo",
  clip_tope_duo: "product-clip-tope-duo",
  cadena_duo: "product-cadena-duo",
  motor_duo: "product-motor-duo",
  motor_control_duo: "product-motor-control-duo",
  confeccion_duo: "product-confeccion-duo",
  instalacion_duo: "product-instalacion-duo"
};

function getBootstrapComponentStock(item, stockBySku) {
  const sku = (item.sku || "").toString().trim().toUpperCase();
  return sku ? stockBySku.get(sku) : null;
}

function resolveRollerComponentPlacement(item) {
  const productKey = normalizeComponentKey(item.productKey);
  const key = normalizeComponentKey(item.key);
  const isDuo = productKey.includes("duo") || key.endsWith("_duo");
  const resolvedKey = isDuo && !key.endsWith("_duo") && rollerComponentClassByKey[`${key}_duo`] ? `${key}_duo` : key;
  const className = rollerComponentClassByKey[resolvedKey] || `product-${handleizeCotizadorComponentKey(key)}${isDuo ? "-duo" : ""}`;
  const container = document.querySelector(isDuo ? ".duo-products" : ".normal-products");
  return { className, container };
}

function upsertBootstrapRollerComponent(item, stockBySku) {
  const key = normalizeComponentKey(item.key);
  const sku = (item.sku || "").toString().trim();
  if (!key || !sku || key.includes("tela_roller")) return null;

  const { className, container } = resolveRollerComponentPlacement(item);
  if (!container) return null;

  let input =
    container.querySelector(`.${className}[data-product-sku='${sku}']`) ||
    container.querySelector(`.${className}`) ||
    document.querySelector(`.${className}[data-product-sku='${sku}']`) ||
    document.querySelector(`.${className}`);

  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-${className}-${sku}`;
    input.className = className;
    input.dataset.bootstrapComponent = "true";
    container.appendChild(input);
  }

  const stock = getBootstrapComponentStock(item, stockBySku);
  const price = Number.isFinite(Number(item.price)) ? Number(item.price) : (stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : 0);
  const quantity = Number.isFinite(Number(item.quantity)) ? Number(item.quantity) : (stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(input.dataset.productQuantity || 0));

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland || getBootstrapSoftlandSku(item.softland) || sku);
  setBootstrapDatasetValue(input, "descripcionSoftland", item.descripcionSoftland || (stock && stock.description) || item.name);
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", item.available === true || quantity > 0 ? "true" : (input.dataset.productAvailable || "false"));
  setBootstrapDatasetValue(input, "productWeight", Number.isFinite(Number(item.weight)) ? item.weight : (input.dataset.productWeight || 0));
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || input.dataset.productWeightUnit || "g");
  setBootstrapDatasetValue(input, "compareAtPrice", item.compareAtPrice || (stock && stock.compareAtPrice));

  return input;
}

function hydrateBootstrapRollerComponents() {
  const bootstrap = getCotizadorBootstrapPayload();
  const componentes = bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [];
  if (componentes.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return componentes
    .filter(item => {
      const productKey = normalizeComponentKey(item.productKey);
      return productKey === "roller" || productKey === "duo" || productKey.startsWith("roller_");
    })
    .map(item => upsertBootstrapRollerComponent(item, stockBySku))
    .filter(Boolean);
}

function refreshHiddenProductoRollerRefs() {
  hidden_producto_sujetador_cadena            = document.querySelector(Selectors.hiddenProducto.sujetadorCadena);
  hidden_producto_unidad_control              = document.querySelectorAll(Selectors.hiddenProducto.unidadControl);
  hidden_producto_cadena                      = document.querySelectorAll(Selectors.hiddenProducto.cadena);
  hidden_producto_cierre_cadena               = document.querySelectorAll(Selectors.hiddenProducto.cierreCadena);
  hidden_producto_clip_tope                   = document.querySelectorAll(Selectors.hiddenProducto.clipTope);
  hidden_producto_terminal_riel_inferior      = document.querySelectorAll(Selectors.hiddenProducto.terminalRielInferior);
  hidden_producto_riel_inferior               = document.querySelector(Selectors.hiddenProducto.rielInferior);
  hidden_producto_tubo                        = document.querySelector(Selectors.hiddenProducto.tubo);
  hidden_producto_motor                       = document.querySelector(Selectors.hiddenProducto.motor);
  hidden_producto_motor_control               = document.querySelector(Selectors.hiddenProducto.motorControl);
  hidden_producto_tela_roller                 = document.querySelectorAll(Selectors.hiddenProducto.telaRoller);
  hidden_producto_zuncho                      = document.querySelector(Selectors.hiddenProducto.zuncho);
  hidden_producto_roller_plus                 = document.querySelector(Selectors.hiddenProducto.rollerPlus);
  hidden_producto_confeccion                  = document.querySelector(Selectors.hiddenProducto.confeccion);
  hidden_producto_instalacion                 = document.querySelector(Selectors.hiddenProducto.instalacion);

  hidden_producto_unidad_control_duo          = document.querySelector(Selectors.hiddenProductoDuo.unidadControl);
  hidden_producto_riel_cenefa_duo             = document.querySelectorAll(Selectors.hiddenProductoDuo.rielCenefa);
  hidden_producto_bracket_duo                 = document.querySelector(Selectors.hiddenProductoDuo.bracket);
  hidden_producto_riel_inferior_duo           = document.querySelector(Selectors.hiddenProductoDuo.rielInferior);
  hidden_producto_riel_tubo_inferior_duo      = document.querySelector(Selectors.hiddenProductoDuo.rielTuboInferior);
  hidden_producto_set_terminal_duo            = document.querySelector(Selectors.hiddenProductoDuo.setTerminal);
  hidden_producto_sujetador_cadena_duo        = document.querySelector(Selectors.hiddenProductoDuo.sujetadorCadena);
  hidden_producto_tubo_duo                    = document.querySelector(Selectors.hiddenProductoDuo.tubo);
  hidden_producto_cierre_cadena_duo           = document.querySelectorAll(Selectors.hiddenProductoDuo.cierreCadena);
  hidden_producto_clip_tope_duo               = document.querySelectorAll(Selectors.hiddenProductoDuo.clipTope);
  hidden_producto_cadena_duo                  = document.querySelectorAll(Selectors.hiddenProductoDuo.cadena);
  hidden_producto_tela_roller_duo             = document.querySelectorAll(Selectors.hiddenProductoDuo.telaRoller);
  hidden_producto_motor_duo                   = document.querySelector(Selectors.hiddenProductoDuo.motor);
  hidden_producto_motor_control_duo           = document.querySelector(Selectors.hiddenProductoDuo.motorControl);
  hidden_producto_confeccion_duo              = document.querySelector(Selectors.hiddenProductoDuo.confeccion);
  hidden_producto_instalacion_duo             = document.querySelector(Selectors.hiddenProductoDuo.instalacion);
}

function renderTelaColorOption(input, colorTelas, index) {
  const dataset = getCotizadorProductDataset(input);
  if (!dataset.productTela || colorTelas.length === 0) return index;

  const telaType = dataset.productTela;
  if (telaType !== "screen") {
    if (colorTelas[0].querySelector(`input[data-value='${dataset.productColor}']`)) return index;
    colorTelas[0].insertAdjacentHTML('beforeend', generateHTMLTemplate(input, index, telaType));
    return index + 1;
  }

  if (telaType === "screen") {
    colorTelas.forEach(colorTela => {
      if (dataset.productTipo == colorTela.parentNode.dataset.productTipo) {
        if (colorTela.querySelector(`input[data-value='${dataset.productColor}']`)) return;
        colorTela.insertAdjacentHTML('beforeend', generateHTMLTemplate(input, index, telaType));
        colorTela.parentNode.classList.add("show");
        index++;
      }
    });
  }

  return index;
}

function getDisplayValueFromHandle(value) {
  return (value || "")
    .toString()
    .split("-")
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function getRollerTelaTypeProducts() {
  const tipoCortina = form_cotizado_cortina_tipo.value || "roller";
  const containerClass = tipoCortina === "roller-duo" ? "duo-products" : "normal-products";
  const className = tipoCortina === "roller-duo" ? "product-tela-roller-duo" : "product-tela-roller";

  return getRollerTelaProductsFromStore()
    .filter(product => product.containerClass === containerClass && product.className === className);
}

function ensureTelaTipoOption(productTela) {
  if (!productTela || document.querySelector(`input[name='tela-tipos'][data-value='${productTela}']`)) return;

  const radios = document.querySelector(".option2 .radios.primary");
  if (!radios) return;

  const index = document.querySelectorAll("input[name='tela-tipos']").length + 1;
  const label = getDisplayValueFromHandle(productTela);
  const isScreen = productTela === "screen";

  radios.insertAdjacentHTML("beforeend", `
    <div class="radio-wrap">
      <input type="radio" class="radio tela-tipos" id="tela_tipos_ws_${index}" name="tela-tipos" data-value="${productTela}" data-type-value="${productTela}" data-cortina-roller="true" data-cortina-roller-duo="true" data-option-screen="${isScreen ? "true" : "false"}" value="${label}">
      <label for="tela_tipos_ws_${index}">${label}</label>
    </div>`);
}

function ensureTelaSuboption(productTipo) {
  if (!productTipo || document.querySelector(`input[name='tela-suboptions'][data-value='${productTipo}']`)) return;

  const telaContainer = document.querySelector(".cotiza-tela-suboption .tela");
  if (!telaContainer) return;

  const index = document.querySelectorAll("input[name='tela-suboptions']").length + 1;
  const label = getDisplayValueFromHandle(productTipo);

  telaContainer.insertAdjacentHTML("beforeend", `
    <div class="suboptions" data-product-tipo="${productTipo}" data-screen-index="${index}">
      <div class="radios">
        <div class="radio-wrap">
          <input type="radio" class="radio tela-suboptions" id="tela_suboptions_ws_${index}" name="tela-suboptions" data-value="${productTipo}" value="${label}">
          <label for="tela_suboptions_ws_${index}">${label}</label>
        </div>
      </div>
      <div class="colores cotiza-tela-color"></div>
    </div>`);
}

function getUniqueCotizadorProducts(products) {
  const seen = new Set();

  return products.filter(product => {
    const dataset = getCotizadorProductDataset(product);
    const key = [
      product.containerClass || "",
      product.className || "",
      dataset.productTela || "",
      dataset.productTipo || "",
      dataset.productColor || ""
    ].join("|");

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function syncTelaOptionsFromProducts(products) {
  const sourceProducts = products || getRollerTelaTypeProducts();
  if (sourceProducts.length === 0) return;

  sourceProducts.forEach(product => {
    const dataset = getCotizadorProductDataset(product);
    ensureTelaTipoOption(dataset.productTela);
    if (dataset.productTela === "screen") {
      ensureTelaSuboption(dataset.productTipo);
    }
  });

  addEventListenerToCollection(document.querySelectorAll(Selectors.form.telaTipos), "click", setCotizacion, "telaTipo");
  addEventListenerToCollection(document.querySelectorAll(Selectors.form.telaTipos), "change", setCotizacion, "telaTipo");
  addEventListenerToCollection(document.querySelectorAll(Selectors.form.telaSuboptions), "click", activeTelaSuboption);
  addEventListenerToCollection(document.querySelectorAll(Selectors.form.telaSuboptions), "change", setCotizacion, "telaSuboption");
}

// Load Cortinas
function loadCortinas() {
  let index = 1;
  const bootstrapTelaProducts = hydrateBootstrapTelaProducts();
  refreshHiddenProductoRollerRefs();
  const storeTelaProducts = getRollerTelaProductsFromStore();
  const allTelaProducts = getUniqueCotizadorProducts(bootstrapTelaProducts.concat(storeTelaProducts));
  const tipoCortina = form_cotizado_cortina_tipo.value || "roller";
  const activeTelaClass = tipoCortina === "roller-duo" ? "product-tela-roller-duo" : "product-tela-roller";
  const activeTelaProducts = allTelaProducts.filter(input => cotizadorProductHasClass(input, activeTelaClass));
  syncTelaOptionsFromProducts(activeTelaProducts);
  let color_telas = document.querySelectorAll(".cotiza-tela-color");
  const fallbackTelaProducts = tipoCortina === "roller-duo"
    ? Array.from(hidden_producto_tela_roller_duo)
    : Array.from(hidden_producto_tela_roller);
  const currentTelaProducts = activeTelaProducts.length > 0 ? activeTelaProducts : fallbackTelaProducts;

  color_telas.forEach(color_tela => { color_tela.innerHTML = ""; });

  currentTelaProducts.forEach(input => {
    index = renderTelaColorOption(input, color_telas, index);
  });

  const labelColoresRadios = document.querySelectorAll(".label-colores");
  addEventListenerToCollection(labelColoresRadios, "click", activeLabelRadio);

  const telaOpcionColoresInputs = document.querySelectorAll("input[name='tela-opcion-colores']");
  addEventListenerToCollection(telaOpcionColoresInputs, "change", setCotizacion, "telaOptionColor");
}
// Formulario Input
const elementsMap = {
  "cortinaTipo": cotizacion_cortina_tipo,
  "confeccionTipo": cotizacion_confeccion_tipo,
  "ancho": cotizacion_ancho,
  "alto": cotizacion_alto,
  "telaTipo": cotizacion_tela_tipo,
  "telaSuboption": cotizacion_tela_suboption,
  "cantidadPano": cotizacion_cantidad_pano,
  "tipoCortina": cotizacion_tipo_cortina,
  "telaOptionColor": cotizacion_tela_suboption,
  "accionamientoTipo": cotizacion_accionamiento_tipo,
  "caidaSentido": cotizacion_caida_sentido,
  "colorAccesorio": cotizacion_color_accesorio,
  "posicionMando": cotizacion_posicion_mando,
  "instalacionCortina": cotizacion_instalacion_cortina,
  "instalacionTipo": cotizacion_instalacion
};

function setValue(field, value) {
  const element = elementsMap[field];

  if (element) {
    if (field === "telaTipo") {
      const tela_option = document.querySelector("input[name='tela-tipos']:checked").dataset.value;
      const tela_suboption = document.querySelector("input[name='tela-suboptions']:checked").value;

      if (tela_option == "screen") {
        element.innerHTML = `${value} - ${tela_suboption}`;
      } else {
        element.innerHTML = value;
      }
    } else if (field === "accionamientoTipo") {
      if (value === "Motorizado" && input_control_motor.checked) {
        element.innerHTML = value + " + Control Remoto";
        form_cotizado_accionamiento_tipo.dataset.value = value + " + Control Remoto";
      } else {
        element.innerHTML = value;
        form_cotizado_accionamiento_tipo.dataset.value = value;
      }
    } else {
      element.innerHTML = value;
    }
  } else {
    console.warn(`Element for field ${field} not found.`);
  }
}

// Formulario Cotizacion
function setCotizacionAncho(event) {
  const inputValue = parseInt(this.value);
  const maxValue = parseInt(this.attributes.max.value);
  const minValue = parseInt(this.attributes.min.value);

  if (inputValue <= maxValue && inputValue >= minValue) {
    setValue("ancho", `${this.value} cm`);
    setFormCotizadoAncho(this.value);
    setForm();
  } else {
    this.value = inputValue > maxValue ? maxValue : minValue;
  }
}

function setCotizacionAlto(event) {
  const inputValue = parseInt(this.value);
  const maxValue = parseInt(this.attributes.max.value);
  const minValue = parseInt(this.attributes.min.value);

  if (inputValue <= maxValue && inputValue >= minValue) {
    setValue("alto", `${this.value} cm`);
    setFormCotizadoAlto(this.value);
    setForm();
  } else {
    this.value = inputValue > maxValue ? maxValue : minValue;
  }
}

function getCurrentValue(attributeName, property = "dataset.value", defaultReturn = null) {
  const elem = document.querySelector(`input[name='${attributeName}']:checked`);
  return elem ? getProperty(elem, property) : defaultReturn;
}

function getProperty(elem, property) {
  const props = property.split('.');
  let value = elem;

  for (const prop of props) {
    if (value) value = value[prop];
    else return null;
  }

  return value;
}

// Elemento para obtener el tipo de cortina seleccionada
function getCurrentTipo() {
  return getCurrentValue('cortina-tipos');
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTela() {
  return getCurrentValue('tela-tipos');
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTelaValue() {
  return getCurrentValue('tela-tipos', "value");
}

// Elemento para obtener el tipo de subtela seleccionada en caso de ser una tela screen
function getCurrentSubtela() {
  return getCurrentValue('tela-suboptions');
}

// Elemento para obtener la primera tela visible de la lista
function getCurrentRadioWrap() {
  return document.querySelector(".radios .show");
}

// Elemento para obtener el primer color de accesorio visible de la lista
function getCurrentColorAccesorio() {
  return document.querySelector(".radios .show");
}

// Elemento para Instalación
function getCurrentInstalacionTipo() {
  return getCurrentValue('instalacion-tipos', "value");
}

function triggerEventsOnFirstRadio() {
  let eClick = new Event('click');
  let eChange = new Event('change');

  // Obtener todos los radios disponibles
  let radio_wraps = document.querySelectorAll(".option2 .suboptions .radio-wrap");

  if (form_cotizado_tela_tipo.value === "screen") {
    for (let radio_wrap of radio_wraps) {
      if (isSuboptionAvailable(radio_wrap) && hasVisibleColorInSuboption(radio_wrap)) {
        radio_wrap.firstElementChild.checked = true;
        radio_wrap.firstElementChild.dispatchEvent(eClick);
        radio_wrap.firstElementChild.dispatchEvent(eChange);
        break; // Salir del bucle una vez que hayamos seleccionado un radio
      }
    }
  } else {
    let radio_wrap = radio_wraps[0];
    radio_wrap.firstElementChild.checked = true;
    radio_wrap.firstElementChild.dispatchEvent(eClick);
    radio_wrap.firstElementChild.dispatchEvent(eChange);
  }
}

function isSuboptionAvailable(radio_wrap) {
  // Lógica para determinar si el radio está disponible.
  // Si tienes clases o atributos de datos que indican la disponibilidad, puedes usarlos aquí.
  // Por ejemplo:
  return radio_wrap.parentElement.parentElement.classList.contains("show");
}

function hasVisibleColorInSuboption(radio_wrap) {
  const suboption = radio_wrap.closest(".suboptions");
  if (!suboption) return false;

  return Array.from(suboption.querySelectorAll(".label-colores")).some(label => !label.classList.contains("hide"));
}

function setTelaColors(params) {
  const { tipo: tela_tipo, tela: tela_option } = params;
  const productType = tela_tipo === "roller" ? ".normal-products" : ".duo-products";
  const productClass = tela_tipo === "roller" ? ".product-tela-roller" : ".product-tela-roller-duo";
  const storeClassName = productClass.replace(".", "");
  const storeContainerClass = productType.replace(".", "");

  turnOffAllColors();

  document.querySelectorAll(Selectors.form.telaColores).forEach(input_tela_opcion_color => {
    if (tela_option === "screen") {
      const suboption = input_tela_opcion_color.closest(".suboptions");
      const productAttribute = suboption ? suboption.dataset.productTipo : "";
      const input_tela = findRollerTelaProductsFromStore({
        productTela: tela_option,
        productTipo: productAttribute,
        productColor: input_tela_opcion_color.dataset.value
      }).filter(product => product.containerClass === storeContainerClass && product.className === storeClassName);
      const fallbackInputTela = input_tela.length > 0
        ? input_tela
        : document.querySelectorAll(`${productType} ${productClass}[data-product-tela='${tela_option}'][data-product-tipo='${productAttribute}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);

      turnOnActiveColors({ "input": fallbackInputTela, "input_tela_opcion_color": input_tela_opcion_color });
    } else {
      const input_tela = findRollerTelaProductsFromStore({
        productTela: tela_option,
        productColor: input_tela_opcion_color.dataset.value
      }).filter(product => product.containerClass === storeContainerClass && product.className === storeClassName);
      const fallbackInputTela = input_tela.length > 0
        ? input_tela
        : document.querySelectorAll(`${productType} ${productClass}[data-product-tela='${tela_option}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);

      turnOnActiveColors({ "input": fallbackInputTela, "input_tela_opcion_color": input_tela_opcion_color });
    }
  });

  triggerEventsOnFirstRadio();
}

function turnOffAllColors() {
  for (let input of document.querySelectorAll(Selectors.form.telaColores)) {
    input.className += " hide";
    input.nextElementSibling.className += " hide";
  }
}

function turnOnActiveColors({ input, input_tela_opcion_color }) {
  if (input && input.length > 0) {
    input_tela_opcion_color.classList.remove("hide");
    input_tela_opcion_color.nextElementSibling.classList.remove("hide");
  }
}

function toggleControlMotorInput({ input, current_action }) {
  const menuContent = document.querySelector(".title-select-h1[data-option-number='3']");

  menuContent.nextElementSibling.style.maxHeight = `${menuContent.parentElement.scrollHeight}px`;
  if (form_cotizado_accionamiento_tipo.dataset.value == 'Normal') {
    input.parentElement.classList.remove("show");
  } else {
    input.parentElement.classList.add("show");
  }
}

function adjustMaxHeight(selector) {
  const element = document.querySelector(selector);
  if (element) {
    element.style.maxHeight = `${element.scrollHeight}px`;
  }
}

function setTelaHeight() {
  adjustMaxHeight('.tela');
  adjustMaxHeight('.cotiza-tela-tipo .content');
}

function setCotizacion(event, configType) {
  switch (configType) {
    case "telaTipo":
      handleTelaTipo(this);
      break;
    case "telaSuboption":
      const tipo_tela = getCurrentTelaValue();
      setValue("telaTipo", tipo_tela);
      setFormCotizadoTelaSuboption(this);
      break;
    case "cortinaTipo":
      setValue("cortinaTipo", `${this.value}`);
      setFormCotizadoCortinaTipo(this);
      loadCortinas();
      checkFormCotizacion();
      break;
    case "motorControl":
      checkFormCotizacion();
      break;
    case "confeccionTipo":
      setValue("confeccionTipo", `${this.value}`);
      setFormCotizadoConfeccionTipo(this);
      break;
    default:
      setValue(configType, this.value);
      setSkuSoftland();
      const setFormFunction = formFunctions[configType];
      if (setFormFunction) setFormFunction(this);
  }

  if (!["instalacionRegion", "instalacionComuna", "nombre", "mensaje"].includes(configType)) {
      setForm();
  }
}

function handleTelaTipo(element) {
  const telaSuboptionElement = document.querySelector(".cotiza-tela-suboption");
  const telaSuboptionFirstChild = telaSuboptionElement.firstElementChild;
  const telaSuboptions = telaSuboptionElement.querySelector(".tela-suboptions");

  if (element.dataset.optionScreen === "true") {
    telaSuboptionFirstChild.innerHTML = `Selecciona ${element.value}`;
    telaSuboptionElement.classList.add("show");
    telaSuboptionElement.classList.remove("no-screen");
  } else {
    telaSuboptionFirstChild.innerHTML = `Selecciona Color`;
    telaSuboptionElement.classList.remove("show", "no-duo");
    telaSuboptionElement.classList.add("no-screen");

    if (element.dataset.value == "duo") {
      telaSuboptionElement.classList.add("no-duo");
    } else {
      telaSuboptions.classList.add("show");
    }
  }

  setTelaColors({ "tipo": getCurrentTipo(), "tela": getCurrentTela() });
  setValue("telaTipo", element.value);
  setFormCotizadoTelaTipo(element);
  setTelaHeight();
}

const formFunctions = {
  "telaOptionColor": setFormCotizadoTelaOpcionColor,
  "accionamientoTipo": setFormCotizadoAccionamientoTipo,
  "caidaSentido": setFormCotizadoCaidaSentido,
  "colorAccesorio": setFormCotizadoColorAccesorio,
  "posicionMando": setFormCotizadoPosicionMando,
  "instalacionCortina": setFormCotizadoInstalacionCortina,
  "instalacionTipo": setFormCotizadoInstalacionTipo
};

// Las siguientes funciones no se han modificado porque ya son concisas
function setCotizacionMotorControl(event) {
  triggerRadioMotor();
  if (hidden_producto_motor !== null) {
    setValue("accionamientoTipo", "Motorizado");
  } else {
    setValue("accionamientoTipo", "Normal");
  }
}
function setCotizacionInstalacionRegion(event) {
  setFormCotizadoInstalacionRegion(this.value);
}

function setCotizacionInstalacionComuna(event) {
  setFormCotizadoInstalacionComuna(this.value);
}

function setCotizacionInstalacionDireccion(event) {
  setFormCotizadoInstalacionDireccion(this.value);
}

function setCotizacionNombre(event) {
  setFormCotizadoNombre(this.value);
}

function setCotizacionMensaje(event) {
  setFormCotizadoMensaje(this.value);
}

// Formulario Cotizado
function updateFormCotizado(target, input) {
  if (typeof input === "string") {
    target.value = input;
  } else {
    target.value = input.dataset.value;
    if (target.value === "motorizado" && input_control_motor.checked) {
      target.dataset.value = input.value + " + Control Remoto";
    } else {
      target.dataset.value = input.value;
    }
  }
}

function setSkuSoftland() {
  const sku_softland = document.querySelector("input[name='tela-opcion-colores']:checked");

  if (sku_softland) {
    if (sku_softland.dataset.skuSoftland !== 'undefined') {
      form_cotizado_homologado_venta.value = sku_softland.dataset.skuSoftland;

      const radio = sku_softland.parentElement.parentElement
        .firstElementChild
        .getElementsByClassName("tela-suboptions")[0]; // accede al primero si hay más de uno

      if (radio) {
        radio.checked = true;
        // Crea un nuevo evento de cambio
        var event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });

        // Despacha el evento de cambio
        radio.dispatchEvent(event);
      }
    } else {
      form_cotizado_homologado_venta.value = '';
    }
  } else {
    form_cotizado_homologado_venta.value = '';
  }
}

function setFormCotizadoCortinaTipo(input) {
  updateFormCotizado(form_cotizado_cortina_tipo, input);
  input_cortina_tipos.forEach(input_cortina_tipo => {
    input_cortina_tipo.parentNode.parentNode.classList.remove("active");
  });
  input.parentNode.parentNode.classList.add("active");
}

function setFormCotizadoConfeccionTipo(value) {
  updateFormCotizado(form_cotizado_confeccion_tipo, value);
}

function setFormCotizadoAncho(value) {
  updateFormCotizado(form_cotizado_ancho, value);
}

function setFormCotizadoAlto(value) {
  updateFormCotizado(form_cotizado_alto, value);
}

function setFormCotizadoTelaTipo(input) {
  updateFormCotizado(form_cotizado_tela_tipo, input);
}

function setFormCotizadoTelaSuboption(input) {
  updateFormCotizado(form_cotizado_tela_suboption, input);
}

function setFormCotizadoTelaOpcionColor(input) {
  updateFormCotizado(form_cotizado_tela_opcion_color, input);
}

function setFormCotizadoAccionamientoTipo(input) {
  toggleControlMotorInput({ "input": input_control_motor });
  updateFormCotizado(form_cotizado_accionamiento_tipo, input);
}

function setFormCotizadoCaidaSentido(input) {
  updateFormCotizado(form_cotizado_caida_sentido, input);
}

function setFormCotizadoCantidadPano(input) {
  updateFormCotizado(form_cotizado_cantidad_pano, input);
}

function setFormCotizadoTipoCortina(input) {
  updateFormCotizado(form_cotizado_tipo_cortina, input);
}

function setFormCotizadoColorAccesorio(input) {
  updateFormCotizado(form_cotizado_color_accesorio, input);
}

function setFormCotizadoPosicionMando(input) {
  updateFormCotizado(form_cotizado_mando_posicion, input);
}

function setFormCotizadoInstalacionCortina(input) {
  updateFormCotizado(form_cotizado_cortina_instalacion, input);
}

function setFormCotizadoInstalacionTipo(input) {
  updateFormCotizado(form_cotizado_instalacion, input);
}

function setFormCotizadoInstalacionRegion(value) {
  updateFormCotizado(form_cotizado_instalacion_region, input_instalacion_region.options[input_instalacion_region.selectedIndex].text);
}

function setFormCotizadoInstalacionComuna(value) {
  updateFormCotizado(form_cotizado_instalacion_comuna, input_instalacion_comuna.options[input_instalacion_comuna.selectedIndex].text);
}

function setFormCotizadoInstalacionDireccion(value) {
  updateFormCotizado(form_cotizado_instalacion_direccion, value);
}

function setFormCotizadoNombre(value) {
  updateFormCotizado(form_cotizado_nombre, value);
}

function setFormCotizadoMensaje(value) {
  updateFormCotizado(form_cotizado_mensaje, value);
}

// Hidden Form Productos
function updateHiddenFormProduct(targetElement, params) {
  const { input, value, grams } = params;
  const dataset = input && input.dataset ? input.dataset : null;

  // Asignar el valor directamente y luego ajustar si es necesario.
  targetElement.value = value || (input && input.value) || 0;

  if (dataset) {
    if ('productAvailable' in dataset) {
      targetElement.dataset.productAvailable = dataset.productAvailable;
    }

    if ('productQuantity' in dataset) {
      targetElement.dataset.productQuantity = dataset.productQuantity;
    }

    if ('productSku' in dataset) {
      targetElement.dataset.productSku = dataset.productSku;
    }

    if ('productWeight' in dataset) {
      targetElement.dataset.productWeight = dataset.productWeight;
    }

    if ('productTitle' in dataset) {
      targetElement.dataset.productTitle = dataset.productTitle;
    }

    if ('descripcionSoftland' in dataset) {
      targetElement.dataset.descripcionSoftland = dataset.descripcionSoftland;
    }

    if ('skuSoftland' in dataset) {
      targetElement.dataset.skuSoftland = dataset.skuSoftland;
    }

    if ('productWeightUnit' in dataset) {
      targetElement.dataset.productWeightUnit = dataset.productWeightUnit;
    }

    if (value === 0) {
      targetElement.value = 0;
    }
  }

  if (grams) {
    targetElement.dataset.grams = grams;
  }
}


function setHiddenFormProductoSujetadorCadena(params) {
  updateHiddenFormProduct(hidden_form_producto_sujetador_cadena, params);
}

function setHiddenFormProductoUnidadControl(params) {
  updateHiddenFormProduct(hidden_form_producto_unidad_control, params);
}

function setHiddenFormProductoCadena(params) {
  updateHiddenFormProduct(hidden_form_producto_cadena, params);
}

function setHiddenFormProductoCierreCadena(params) {
  updateHiddenFormProduct(hidden_form_producto_cierre_cadena, params);
}

function setHiddenFormProductoClipTope(params) {
  updateHiddenFormProduct(hidden_form_producto_clip_tope, params);
}

function setHiddenFormProductoTerminalRielInferior(params) {
  updateHiddenFormProduct(hidden_form_producto_terminal_riel_inferior, params);
}

function setHiddenFormProductoRielInferior(params) {
  updateHiddenFormProduct(hidden_form_producto_riel_inferior, params);
}

function setHiddenFormProductoTubo(params) {
  updateHiddenFormProduct(hidden_form_producto_tubo, params);
}

function setHiddenFormProductoMotor(params) {
  updateHiddenFormProduct(hidden_form_producto_motor, params);
}

function setHiddenFormProductoMotorControl(params) {
  updateHiddenFormProduct(hidden_form_producto_motor_control, params);
}

function setHiddenFormProductoTelaRoller(params) {
  updateHiddenFormProduct(hidden_form_producto_tela_roller, params);
}

function setHiddenFormProductoPesoEnvio(params) {
  updateHiddenFormProduct(hidden_form_producto_peso_envio, params);
}

function setHiddenFormProductoZuncho(params) {
  updateHiddenFormProduct(hidden_form_producto_zuncho, params);
}

function setHiddenFormProductoPlus(params) {
  updateHiddenFormProduct(hidden_form_producto_roller_plus, params);
}

function setHiddenFormProductoConfeccion(params) {
  updateHiddenFormProduct(hidden_form_producto_confeccion, params);
}

function setHiddenFormProductoInstalacion(params) {
  updateHiddenFormProduct(hidden_form_producto_instalacion, params);
}

// Hidden Form Productos Duo
function updateHiddenFormProductDuo(targetElement, params) {
  const { input, value, grams } = params;

  // Si se proporciona 'input', establecemos sus propiedades
  if (input) {
    targetElement.value = input.value || value;
    targetElement.dataset.productAvailable = input.dataset.productAvailable;
    targetElement.dataset.productQuantity = input.dataset.productQuantity;
    targetElement.dataset.productSku = input.dataset.productSku;
    targetElement.dataset.productWeight = input.dataset.productWeight;
  }

  // Si se proporciona 'grams', lo establecemos
  if (grams) {
    targetElement.dataset.grams = grams;
  }
}

function setHiddenFormProductoUnidadControlDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_unidad_control_duo, params);
}

function setHiddenFormProductoRielCenefaDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_riel_cenefa_duo, params);
}

function setHiddenFormProductoBracketDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_bracket_duo, params);
}

function setHiddenFormProductoRielInferiorDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_riel_inferior_duo, params);
}

function setHiddenFormProductoRielTuboInferiorDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_riel_tubo_inferior_duo, params);
}

function setHiddenFormProductoSetTerminalDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_set_terminal_duo, params);
}

function setHiddenFormProductoSujetadorCadenaDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_sujetador_cadena_duo, params);
}

function setHiddenFormProductoTuboDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_tubo_duo, params);
}

function setHiddenFormProductoCierreCadenaDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_cierre_cadena_duo, params);
}

function setHiddenFormProductoClipTopeDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_clip_tope_duo, params);
}

function setHiddenFormProductoCadenaDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_cadena_duo, params);
}

function setHiddenFormProductoMotorDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_motor_duo, params);
}

function setHiddenFormProductoMotorControlDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_motor_control_duo, params);
}

function setHiddenFormProductoTelaRollerDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_tela_roller_duo, params);
}

function setHiddenFormProductoPesoEnvioDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_peso_envio_duo, params);
}

function setHiddenFormProductoConfeccionDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_confeccion_duo, params);
}

function setHiddenFormProductoInstalacionDuo(params) {
  updateHiddenFormProduct(hidden_form_producto_instalacion_duo, params);
}

// hidden Products
function queryProductByColor(productType, productClass) {
  const containerClass = `${productType}-products`;
  const className = productClass.replace(".", "");
  const storeProduct = typeof findCotizadorProduct === "function"
    ? findCotizadorProduct({
      containerClass,
      className,
      productColor: form_cotizado_color_accesorio.value
    })
    : null;

  if (storeProduct) return storeProduct;

  const current_checked = document.querySelector(`.${productType}-products ${productClass}[data-product-color='${form_cotizado_color_accesorio.value}']`);
  const fallbackProduct = typeof findCotizadorProduct === "function"
    ? findCotizadorProduct({ containerClass, className })
    : null;

  return current_checked || fallbackProduct || document.querySelector(`.${productType}-products ${productClass}`) || null;
}

function getHiddenProductoUnidadControl() {
  return queryProductByColor("normal", ".product-unidad-control");
}

function getHiddenProductoCadena() {
  return queryProductByColor("normal", ".product-cadena");
}

function getHiddenProductoCierreCadena() {
  return queryProductByColor("normal", ".product-cierre-cadena");
}

function getHiddenProductoClipTope() {
  return queryProductByColor("normal", ".product-clip-tope");
}

function getHiddenProductoTerminalRielInferior() {
  return queryProductByColor("normal", ".product-terminal-riel-inferior");
}

function getHiddenProductoRielInferior() {
  return queryProductByColor("normal", ".product-riel-inferior");
}

function getHiddenProductoTelaRoller() {
  let current_checked = null;
  let sku = "";
  let skuValue = "";
  if (document.querySelector("input[name='tela-opcion-colores']:checked") !== null) {
    skuValue = document.querySelector("input[name='tela-opcion-colores']:checked").dataset.sku;
    sku = `[data-product-sku='${skuValue}']`;
  }

  const storeFilters = {
    containerClass: "normal-products",
    className: "product-tela-roller",
    productColor: form_cotizado_tela_opcion_color.value,
    productTela: form_cotizado_tela_tipo.value
  };

  if (skuValue) {
    storeFilters.productSku = skuValue;
  }

  if (form_cotizado_tela_tipo.value === "screen") {
    storeFilters.productTipo = form_cotizado_tela_suboption.value;
  }

  if (typeof findCotizadorProduct === "function") {
    current_checked = findCotizadorProduct(storeFilters);
    if (current_checked) return current_checked;
  }

  if (form_cotizado_tela_tipo.value === "screen") {
    current_checked = document.querySelector(`.normal-products .product-tela-roller${sku}[data-product-color='${form_cotizado_tela_opcion_color.value}'][data-product-tipo='${form_cotizado_tela_suboption.value}'][data-product-tela='${form_cotizado_tela_tipo.value}']`);
  } else {
    current_checked = document.querySelector(`.normal-products .product-tela-roller${sku}[data-product-color='${form_cotizado_tela_opcion_color.value}'][data-product-tela='${form_cotizado_tela_tipo.value}']`);
  }
  return current_checked;
}

// hidden Products Duo
function getHiddenProductoRielCenefaDuo() {
  return queryProductByColor("duo", ".product-riel-cenefa-duo");
}

function getHiddenProductoCierreCadenaDuo() {
  return queryProductByColor("duo", ".product-cierre-cadena-duo");
}

function getHiddenProductoClipTopeDuo() {
  return queryProductByColor("duo", ".product-clip-tope-duo");
}

function getHiddenProductoCadenaDuo() {
  return queryProductByColor("duo", ".product-cadena-duo");
}

function getHiddenProductoTelaRollerDuo() {
  let sku = "";
  let skuValue = "";
  if (document.querySelector("input[name='tela-opcion-colores']:checked") !== null) {
    skuValue = document.querySelector("input[name='tela-opcion-colores']:checked").dataset.sku;
    sku = `[data-product-sku='${skuValue}']`;
  }

  const storeFilters = {
    containerClass: "duo-products",
    className: "product-tela-roller-duo",
    productColor: form_cotizado_tela_opcion_color.value
  };

  if (skuValue) {
    storeFilters.productSku = skuValue;
  }

  if (typeof findCotizadorProduct === "function") {
    const storeProduct = findCotizadorProduct(storeFilters);
    if (storeProduct) return storeProduct;
  }

  let current_checked = document.querySelector(`.duo-products .product-tela-roller-duo${sku}[data-product-color='${form_cotizado_tela_opcion_color.value}']`);
  return current_checked;
}

function getDescripcionSoftlandFromSelection() {
  const tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
  const selectedProduct = tipo_cortina === "roller-duo" ? getHiddenProductoTelaRollerDuo() : getHiddenProductoTelaRoller();
  if (selectedProduct && selectedProduct.dataset) {
    return (selectedProduct.dataset.descripcionSoftland || "").trim();
  }
  return "";
}

// Calculos
function calculaCotizacion() {
  const total = getTotal();
  const total_precio = total.toString().replace(MONEY_REGEX, ".");

  updateDOM(total, total_precio);
}

function updateDOM(total, total_precio) {
  total_precio_input.value    = total;
  total_precio_html.innerHTML = `$${total_precio}`;
}

function getTotal() {
  const tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
  const tipo_accionamiento = document.querySelector("input[name='accionamiento-tipos']:checked").dataset.value;
  const motor_control = input_control_motor.checked;

  let productElements = [];

  switch (tipo_cortina) {
    case 'roller':
      productElements = [hidden_form_producto_sujetador_cadena, hidden_form_producto_unidad_control, hidden_form_producto_cadena, hidden_form_producto_cierre_cadena, hidden_form_producto_clip_tope, hidden_form_producto_terminal_riel_inferior, hidden_form_producto_riel_inferior, hidden_form_producto_tubo, hidden_form_producto_tela_roller, hidden_form_producto_zuncho, hidden_form_producto_confeccion, hidden_form_producto_instalacion];
      if (form_cotizado_confeccion_tipo.value === 'plus' && hidden_form_producto_roller_plus) productElements.push(hidden_form_producto_roller_plus);

      if (tipo_accionamiento === 'motorizado') {
        productElements.push(hidden_form_producto_motor);
        if (motor_control) productElements.push(hidden_form_producto_motor_control);
      }
      break;
    case 'roller-duo':
      productElements = [hidden_form_producto_unidad_control_duo, hidden_form_producto_riel_cenefa_duo, hidden_form_producto_bracket_duo, hidden_form_producto_riel_inferior_duo, hidden_form_producto_riel_tubo_inferior_duo, hidden_form_producto_set_terminal_duo, hidden_form_producto_sujetador_cadena_duo, hidden_form_producto_tubo_duo, hidden_form_producto_cierre_cadena_duo, hidden_form_producto_clip_tope_duo, hidden_form_producto_cadena_duo, hidden_form_producto_tela_roller_duo, hidden_form_producto_confeccion_duo, hidden_form_producto_instalacion_duo];
      if (form_cotizado_confeccion_tipo.value === 'plus' && hidden_form_producto_roller_plus) productElements.push(hidden_form_producto_roller_plus);

      if (tipo_accionamiento === 'motorizado') {
        productElements.push(hidden_form_producto_motor_duo);
        if (motor_control) productElements.push(hidden_form_producto_motor_control_duo);
      }
      break;
    default:
      return 0; // o puedes manejar otras cortinas aquí
  }

  return Math.round(calculateTotal(productElements));
}

function calculateTotal(productElements) {
  return productElements.reduce((acc, elem) => {
    if (!elem) return acc;
    return acc + parseInt(elem.value || 0);
  }, 0);
}

function getFormQuote() {
  // Cotizador
  const tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
  const accionamiento_tipo = document.querySelector("input[name='accionamiento-tipos']:checked").dataset.value;
  const hasInstalacion = hidden_form_producto_instalacion.value !== "0";
  let quoteText = `<h3 class="inner-title">Resumen Productos</h3>`;

  let products = {
    roller: {
      normal: ["sujetador_cadena", "unidad_control", "cadena", "cierre_cadena", "clip_tope", "terminal_riel_inferior", "riel_inferior", "tubo", "tela_roller"],
      motorizado: ["sujetador_cadena", "unidad_control", "cadena", "cierre_cadena", "clip_tope", "terminal_riel_inferior", "riel_inferior", "tubo", "motor", "tela_roller"]
    },
    'roller-duo': {
      normal: ["unidad_control_duo", "riel_cenefa_duo", "bracket_duo", "riel_inferior_duo", "riel_tubo_inferior_duo", "set_terminal_duo", "sujetador_cadena_duo", "tubo_duo", "cierre_cadena_duo", "clip_tope_duo", "cadena_duo", "tela_roller_duo"],
      motorizado: ["unidad_control_duo", "riel_cenefa_duo", "bracket_duo", "riel_inferior_duo", "riel_tubo_inferior_duo", "set_terminal_duo", "sujetador_cadena_duo", "tubo_duo", "cierre_cadena_duo", "clip_tope_duo", "cadena_duo", "motor_duo", "tela_roller_duo"]
    }
  };

  if (form_cotizado_confeccion_tipo.value === 'plus') products[tipo_cortina][accionamiento_tipo].push("roller_plus");
  if (accionamiento_tipo === 'motorizado' && input_control_motor.checked) products[tipo_cortina][accionamiento_tipo].push("motor_control");

  products[tipo_cortina][accionamiento_tipo].forEach(product => {
    const productValue = eval('hidden_form_producto_' + product);
    quoteText += `<div class="line line-sku"><span class="var var-title">${formatTitle(product)}:</span><span class="val val-sku"> ${productValue.dataset.productSku}</span></div>`;
  });

  if (hasInstalacion) {
    quoteText += `
      <div class="line line-sku"><span class="var var-title">Instalación Región:</span><span class="val val-sku"> ${form_cotizado_instalacion_region.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Comuna:</span><span class="val val-sku"> ${form_cotizado_instalacion_comuna.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Dirección:</span><span class="val val-sku"> ${form_cotizado_instalacion_direccion.value}</span></div>`;
  }

  quoteText += `
    <div class="line line-sku"><span class="var var-title">Nombre:</span><span class="val val-sku"> ${form_cotizado_nombre.value}</span></div>
    <div class="line line-sku last"><span class="var var-title">Mensaje:</span><span class="val val-instalacion-cortina"> ${form_cotizado_mensaje.value}</span></div>
    <div class="line line-sku last"><span class="var var-title">Código:</span><span class="val val-codigo"> ${form_cotizado_homologado_venta.value}</span></div>`;

  return quoteText;
}

function formatTitle(product) {
  // Convertir snake_case a Title Case
  return product.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function setImagePreview({ input }) {
  if (input) {
    const { productImage, productImageZoom, productImageExtra, productImageExtraZoom } = input.dataset;

    // Actualizar imagen principal
    preview_image.src = productImage;
    preview_image.srcset = productImage;
    preview_image.parentElement.href = productImageZoom;

    // Actualizar imagen extra
    preview_image_zoom.src = productImageExtra;
    preview_image_zoom.srcset = productImageExtra;
    preview_image_zoom.parentElement.href = productImageExtraZoom;

    $('.easyzoom').each(function() {
      const easyzoomInstance = $(this).data('easyZoom');
      easyzoomInstance.teardown();
      $(this).easyZoom({
        loadingNotice: 'Cargando imagen'
      });
    });
  }
}

// Calculate Normal
// ((D4*(C22/100)*2)*1,25)
function calculateCadena(params) {
  // Obtener los valores una sola vez
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_alto.value);

  // Realizar el cálculo usando los valores obtenidos
  const total = Math.round(inputValue * (formValue / 100) * 2 * 1.25);

  setHiddenFormProductoCadena({"input": params["input"], "value": total});
}

// (((D8/5.8)*B23/100)*1,25)
function calculateRielInferior(params) {
  // Obtener los valores numéricos una sola vez
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  // Realizar el cálculo usando los valores previamente obtenidos
  const total = Math.round((inputValue / 5.8) * (formValue / 100) * 1.25);

  setHiddenFormProductoRielInferior({"input": params["input"], "value": total});
}

// (((D9/5,8)*(B23/100))*1,25)
function calculateTubo(params) {
  // Obtener los valores numéricos una sola vez
  const inputValue = parseFloat(params["value"]);
  const formValue = parseFloat(form_cotizado_ancho.value);

  // Realizar el cálculo usando los valores previamente obtenidos
  const total = Math.round((inputValue / 5.8) * (formValue / 100) * 1.25);

  setHiddenFormProductoTubo({"input": params["input"], "value": total});
}

// ((D10*(B23/100))*1,25)
function calculateZuncho(params) {
  // Obtener los valores numéricos una sola vez
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  // Realizar el cálculo usando los valores previamente obtenidos
  const total = Math.round(inputValue * (formValue / 100) * 1.25);

  setHiddenFormProductoZuncho({"input": params["input"], "value": total});
}

// ((D21/5,8)*1,25*(B23/100))
function calculatePlus(params) {
  const confeccionValue = form_cotizado_confeccion_tipo.value;
  const plusInput = params["input"];

  // Si no es 'plus', establecer directamente el valor en 0
  if (confeccionValue !== "plus") {
    setHiddenFormProductoPlus({ "input": plusInput, "value": 0 });
    return;
  }

  if (!plusInput) {
    setHiddenFormProductoPlus({ "value": PLUS_PRICE_GUARD_VALUE });
    return;
  }

  // Obtener los valores numéricos una sola vez
  const inputValue = parseFloat(plusInput.value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  // Realizar el cálculo usando los valores previamente obtenidos
  const total = Math.round((inputValue / 5.8) * 1.25 * (formValue / 100));

  setHiddenFormProductoPlus({"input": plusInput, "value": total});
}

// (((C22/100)+(20/100))*1,25*H13)
function calculateTelaRoller(params) {
  const input = params["input"];

  if (input) {
    setImagePreview({"input": input});

    // Obtener los valores numéricos una sola vez
    const formValue = parseFloat(form_cotizado_alto.value) / 100;
    const inputValue = parseFloat(input.value);

    // Realizar el cálculo usando los valores previamente obtenidos
    const total = Math.round((formValue + 0.20) * 1.25 * inputValue);

    setHiddenFormProductoTelaRoller({"input": input, "value": total});
  }
}

function calculateTotalWeight(params) {
  // Almacenamos todos los valores en un array
  const products = [params["sujetador"], params["unidad_control"], params["cierre_cadena"], params["clip_tope"], params["motor"], params["terminal"], params["cadena"], params["riel"], params["tubo"], params["zuncho"], params["tela"]];

  // Sumamos todos los pesos utilizando el método reduce
  const totalWeight = products.reduce((acc, product) => {
    if (product) {
      const weight = parseInt(product.dataset.productWeight);

      // Consideramos la multiplicación para 'tela'
      if (product === params["tela"]) {
        return acc + (weight * Math.ceil(input_ancho.value / 100));
      }
      return acc + weight;
    }
    return acc;
  }, 0);

  const peso = totalWeight / 1000;
  setHiddenFormProductoPesoEnvio({"value": peso, "grams": peso * 1000});
}

// (K13*(B23*C22)/10000)
function calculateConfeccion(params) {
  const input = params["input"];

  // Obtener valores numéricos una sola vez
  const inputValue = parseFloat(input.value);
  const anchoValue = parseFloat(form_cotizado_ancho.value);
  const altoValue = parseFloat(form_cotizado_alto.value);

  // Calcular el total
  const total = Math.round(inputValue * (anchoValue * altoValue / 10000));

  setHiddenFormProductoConfeccion({"input": input, "value": total});
}

// Calculate Duo
// (((D4/5,8)*B37)*1,25)
function calculateRielCenefaDuo(params) {
  const inputValue = parseFloat(params["input"].value);
  const anchoValue = parseFloat(form_cotizado_ancho.value);

  const total = Math.round((inputValue / 5.8) * (anchoValue / 100) * 1.25);

  setHiddenFormProductoRielCenefaDuo({"input": params["input"], "value": total});
}

// (D5*2)
function calculateBracketDuo(params) {
  const total = Math.round(parseFloat(params["input"].value) * 2);
  setHiddenFormProductoBracketDuo({"input": params["input"], "value": total});
}

// (((D6/5,8)*B37)*1,25)
function calculateRielInferiorDuo(params) {
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  const total = Math.round(((inputValue / 5.8) * (formValue / 100)) * 1.25);

  setHiddenFormProductoRielInferiorDuo({"input": params["input"], "value": total});
}

// (((D7/5,8)*B37)*1,25)
function calculateRielTuboInferiorDuo(params) {
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  const total = Math.round(((inputValue / 5.8) * (formValue / 100)) * 1.25);

  setHiddenFormProductoRielTuboInferiorDuo({"input": params["input"], "value": total});
}

// (((D10/5,8)*B37)*1,25)
function calculateTuboDuo(params) {
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  const total = Math.round(((inputValue / 5.8) * (formValue / 100)) * 1.25);

  setHiddenFormProductoTuboDuo({"input": params["input"], "value": total});
}

// (((D13*2)*C36)*1,25)
function calculateCadenaDuo(params) {
  const inputValue = parseFloat(params["input"].value);
  const formValue = parseFloat(form_cotizado_alto.value);

  const total = Math.round((inputValue * 2 * (formValue / 100)) * 1.25);

  setHiddenFormProductoCadenaDuo({"input": params["input"], "value": total});
}

// ((D21/5,8)*1,25*(B23/100))
function calculatePlusDuo(params) {
  const confeccionValue = form_cotizado_confeccion_tipo.value;
  const plusInput = params["input"];

  // Si no es 'plus', establecer directamente el valor en 0
  if (confeccionValue !== "plus") {
    setHiddenFormProductoPlus({ "input": plusInput, "value": 0 });
    return;
  }

  if (!plusInput) {
    setHiddenFormProductoPlus({ "value": PLUS_PRICE_GUARD_VALUE });
    return;
  }

  // Obtener los valores numéricos una sola vez
  const inputValue = parseFloat(plusInput.value);
  const formValue = parseFloat(form_cotizado_ancho.value);

  // Realizar el cálculo usando los valores previamente obtenidos
  const total = Math.round((inputValue / 5.8) * 1.25 * (formValue / 100));

  setHiddenFormProductoPlus({"input": plusInput, "value": total});
}

// ((((C36*2)+0,2)*1,25)*G16)
function calculateTelaRollerDuo(params) {
  const input = params["input"];
  if (input !== null) {
    setImagePreview({"input": input});

    const formValue = parseFloat(form_cotizado_alto.value);
    const inputValue = parseFloat(input.value);

    const multiplier = ((formValue / 100) * 2 + 0.2) * 1.25;
    const total = Math.round(multiplier * inputValue);

    setHiddenFormProductoTelaRollerDuo({"input": input, "value": total});
  }
}

function calculateTotalWeightDuo(params) {
  const components = ["unidad_control", "set_terminal", "sujetador_cadena", "cierre_cadena", "clip_tope", "motor", "riel_cenefa", "bracket", "riel_inferior", "riel_tubo_inferior", "tubo", "cadena", "tela"];

  let peso = 0;
  let allComponentsPresent = true;

  for (let component of components) {
    if (params[component] === null) {
      allComponentsPresent = false;
      break;
    }

    if (component === "tela") {
      peso += parseInt(params[component].dataset.productWeight) * Math.ceil(input_ancho.value / 100);
    } else {
      peso += parseInt(params[component].dataset.productWeight);
    }
  }

  if (allComponentsPresent) {
    peso /= 1000;
    setHiddenFormProductoPesoEnvioDuo({"value": peso, "grams": peso * 1000});
  }
}

// ((C36*B37)*I16)
function calculateConfeccionDuo(params) {
  const input = params["input"];

  const formAnchoValue = parseFloat(form_cotizado_ancho.value) / 100;
  const formAltoValue = parseFloat(form_cotizado_alto.value) / 100;
  const inputValue = parseFloat(input.value);

  const totalValue = Math.round(formAnchoValue * formAltoValue * inputValue);

  setHiddenFormProductoConfeccionDuo({"input": input, "value": totalValue});
}

// Build HTML Body for product
function buildBodyHTML(params) {
  const { tela_title, formQuote, total_precio_html, disclaimer } = params;

  return `
    <div class="resumen">
      <h3 class="inner-title">Resumen Cotización:<span class="val-cortina-tipo"> ${form_cotizado_cortina_tipo.dataset.value} - ${form_cotizado_nombre.value}</span></h3>
      ${buildLine('Ancho', form_cotizado_ancho.value)}
      ${buildLine('Alto', form_cotizado_alto.value)}
      ${buildLine('Tela', tela_title)}
      ${buildLine('Color Tela', form_cotizado_tela_opcion_color.dataset.value)}
      ${buildLine('Tipo de accionamiento', form_cotizado_accionamiento_tipo.dataset.value)}
      ${buildLine('Tipo de confección', form_cotizado_confeccion_tipo.dataset.value)}
      ${buildLine('Sentido de caída de la tela', form_cotizado_caida_sentido.dataset.value)}
      ${buildLine('Color del accesorio', form_cotizado_color_accesorio.dataset.value)}
      ${buildLine('Posición del mando', form_cotizado_mando_posicion.dataset.value)}
      ${buildLine('Instalación de cortina', form_cotizado_cortina_instalacion.dataset.value)}
      ${buildLine('Instalación a domicilio', form_cotizado_instalacion.dataset.value, true)}
      <div class="bottom">
        <h6 class="precio precio-total">Total: <span>${total_precio_html.innerHTML}</span></h6>
        <p class="red">${disclaimer}</p>
      </div>
      <div class="resumen-p">${formQuote}</div>
    </div>`;
}

// Add line to HTML Body
function buildLine(title, value, last = false) {
  return `<div class="line line-product${last ? ' last' : ''}"><span class="var">${title}:</span><span class="val val-${title.toLowerCase().replace(' ', '-')}> ${value} cm</span></div>`;
}

// Submit Cotizador
async function submitCotizacion() {
  if (validateForm()) {
    try {
      closeAllTitles();
      let formQuote   = getFormQuote();
      let disclaimer  = document.querySelector(".quote-disclaimer").innerHTML;
      let tela_title  = form_cotizado_tela_tipo.dataset.value;
      let peso        = parseInt(hidden_form_producto_peso_envio.value);
      let peso_gramos = parseInt(hidden_form_producto_peso_envio.dataset.grams);
      if (form_cotizado_tela_tipo.value === "screen") {
        tela_title = `${form_cotizado_tela_tipo.dataset.value} - ${form_cotizado_tela_suboption.dataset.value}`;
      }
    if (form_cotizado_cortina_tipo.value === "duo") {
      peso        = parseInt(hidden_form_producto_peso_envio_duo.value);
      peso_gramos = parseInt(hidden_form_producto_peso_envio_duo.dataset.grams);
    }
    const descripcionSoftland = getDescripcionSoftlandFromSelection();

    let body_html = `
      <div class="resumen">
        <h3 class="inner-title">Resumen Cotización:<span class="val-cortina-tipo"> ${form_cotizado_cortina_tipo.dataset.value} - ${form_cotizado_nombre.value}</span></h3>
        <div class="line line-product"><span class="var">Ancho:</span><span class="val val-ancho"> ${form_cotizado_ancho.value} cm</span></div>
        <div class="line line-product"><span class="var">Alto:</span><span class="val val-alto"> ${form_cotizado_alto.value} cm</span></div>
        <div class="line line-product"><span class="var">Tela:</span><span class="val val-tela-tipo"> ${tela_title}</span></div>
        <div class="line line-product"><span class="var">Color Tela:</span><span class="val val-tela-suboption"> ${form_cotizado_tela_opcion_color.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Tipo de accionamiento:</span><span class="val val-accionamiento-tipo"> ${form_cotizado_accionamiento_tipo.dataset.value}</span></div>`
    if (form_cotizado_cortina_tipo.value !== "roller-duo") {
      body_html += `<div class="line line-product"><span class="var">Tipo de Confección:</span><span class="val val-confeccion-tipo"> ${form_cotizado_confeccion_tipo.dataset.value}</span></div>`;
    }
    body_html += `
        <div class="line line-product"><span class="var">Sentido de caída de la tela:</span><span class="val val-caida-sentido"> ${form_cotizado_caida_sentido.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Color del accesorio:</span><span class="val val-color-accesorio"> ${form_cotizado_color_accesorio.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Posición del mando:</span><span class="val val-posicion-mando"> ${form_cotizado_mando_posicion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Instalación de cortina:</span><span class="val val-instalacion-cortina"> ${form_cotizado_cortina_instalacion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Instalación a domicilio:</span><span class="val val-instalacion"> ${form_cotizado_instalacion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Descripción Softland:</span><span class="val val-descripcion-softland"> ${descripcionSoftland}</span></div>
        <div class="line line-product last"><span class="var">Cantidad:</span><span class="val val-quantity"> xxxxx</span></div>
        <div class="bottom">
          <h6 class="precio precio-total">Total: <span>${total_precio_html.innerHTML}</span></h6>
          <p class="red">${disclaimer}</p>
        </div>
        <div class="resumen-p">
          ${formQuote}
        </div>
      </div>`;
      const storeCode = (typeof getCotizadorStoreCode === "function" && getCotizadorStoreCode()) || (window.Shopify.shop || "").split(".")[0];
      const customerEmail = (typeof getCotizadorStoreEmailFallback === "function" && getCotizadorStoreEmailFallback()) || `cotizador@${window.Shopify.shop}`;
      const totalPrice = Number(total_precio_input.value || 0);

      const quotePayload = {
        store: storeCode,
        customerName: form_cotizado_nombre.value || "Cliente Cotizador",
        customerEmail,
        currency: "CLP",
        priceList: "LA",
        notes: form_cotizado_mensaje.value || null,
        items: (typeof buildQuoteItemsFromHiddenProducts === "function" ? buildQuoteItemsFromHiddenProducts(document) : [])
      };

      const tempProductPayload = {
        store: storeCode,
        title: `Cotización - ${form_cotizado_nombre.value}`,
        price: totalPrice,
        currency: "CLP",
        sku: form_cotizado_homologado_venta.value || "COTIZA-B2C",
        quantity: 1,
        descriptionHtml: body_html
      };

      await processCotizadorQuoteTempProductCart({
        quotePayload,
        tempProductPayload,
        quantity: 1
      }, { container: cotiza_container });
      hidden_cotizacion_area.innerHTML = hidden_cotizacion_area.innerHTML + body_html.replaceAll("xxxxx", "1") + "<br><br>";
      document.querySelector(".btn.print").classList.add("show");
      document.querySelector(".btn.email").classList.add("show");
    } catch (error) {
      const quoteContext = (error && error.message) ? error.message : "sin contexto";
      console.error("Error en flujo v3 cotizador (quote/temp-product/cart)", quoteContext, error);
      if (typeof showCotizadorFunctionalError === "function") {
        showCotizadorFunctionalError("No se pudo procesar la cotización en este momento.");
      }
    }
  }
}

function validateForm() {
  const TITLE_SELECTOR = ".title-select-h1[data-option-number='{num}']";
  const SUBTITLE_SELECTOR = ".title-select-h4[data-option-number='{num}']";

  const validations = [
    {
      condition: () => form_cotizado_cortina_tipo.value.length == 0,
      focusElement: input_cortina_tipos[0]
    },
    {
      condition: () => form_cotizado_ancho.value.length == 0 || parseInt(form_cotizado_ancho.value) < input_ancho.min || parseInt(form_cotizado_ancho.value) > input_ancho.max,
      focusElement: input_ancho,
      title: TITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_alto.value.length == 0 || parseInt(form_cotizado_alto.value) < input_alto.min || parseInt(form_cotizado_alto.value) > input_alto.max,
      focusElement: input_alto,
      title: TITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_tela_tipo.value.length == 0,
      focusElement: input_tela_tipos[0],
      title: TITLE_SELECTOR.replace('{num}', '2')
    },
    {
      condition: () => form_cotizado_tela_suboption.value.length == 0,
      focusElement: input_tela_suboptions[0],
      title: TITLE_SELECTOR.replace('{num}', '2'),
      subtitle: SUBTITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_tela_opcion_color.value.length == 0,
      focusElement: input_tela_opcion_colores[0],
      title: TITLE_SELECTOR.replace('{num}', '2'),
      subtitle: SUBTITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_caida_sentido.value.length == 0,
      focusElement: input_caida_sentidos[0],
      title: TITLE_SELECTOR.replace('{num}', '4')
    },
    {
      condition: () => form_cotizado_mando_posicion.value.length == 0,
      focusElement: input_mando_posiciones[0],
      title: TITLE_SELECTOR.replace('{num}', '5')
    },
    {
      condition: () => form_cotizado_color_accesorio.value.length == 0,
      focusElement: input_color_accesorios[0],
      title: TITLE_SELECTOR.replace('{num}', '7')
    },
    {
      condition: () => form_cotizado_cortina_instalacion.value.length == 0,
      focusElement: input_cortina_instalaciones[0],
      title: TITLE_SELECTOR.replace('{num}', '7')
    },
    {
      condition: () => region_select.value === '1' && region_direccion.value.length === 0 && parseInt(form_cotizado_instalacion.value) !== 0,
      focusElement: input_instalacion_direccion,
      title: TITLE_SELECTOR.replace('{num}', '8')
    },
    {
      condition: () => form_cotizado_nombre.value.length == 0 || form_cotizado_nombre.value.length > input_nombre.maxLength,
      focusElement: input_nombre,
      title: TITLE_SELECTOR.replace('{num}', '9')
    },
    {
      condition: () => form_cotizado_mensaje.value.length == 0 || form_cotizado_mensaje.value.length > input_mensaje.maxLength,
      focusElement: input_mensaje,
      title: TITLE_SELECTOR.replace('{num}', '9')
    }
  ];

  for (let validation of validations) {
    if (validation.condition()) {
      closeAllTitles();

      if (validation.title) {
        openTitle(document.querySelector(validation.title));
      }

      if (validation.subtitle) {
        openSubtitle(document.querySelector(validation.subtitle));
      }

      validation.focusElement.focus();
      return false;
    }
  }

  return true;
}

function indexInParent(node) {
  let children = node.parentNode.childNodes;
  let num      = 0;
  for (let i = 0; i < children.length; i++) {
    if (children[i] === node) return num;
    if (children[i].nodeType === 1) num++;
  }
  return -1;
}

function findGetParameter(parameterName) {
  var result = null, tmp = [];
  location.search.slice(1).split("&").forEach(function(item) {
    tmp = item.split("=");
    if (tmp[0] === parameterName) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
}

function updateInnerHTMLFromContainer(selector, container) {
  const currentEl = document.querySelector(selector);
  const nextEl = container.querySelector(selector);
  if (currentEl && nextEl) {
    currentEl.innerHTML = nextEl.innerHTML;
  }
}

async function addToCartLikeTheme(variantId, quantity = 1) {
  if (!variantId) {
    throw new Error("No se encontró la variante");
  }

  const addPayload = { items: [{ id: variantId, quantity }] };
  const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(addPayload)
  });
  const addResult = await addResponse.json();

  if (addResult && addResult.status === 422) {
    throw new Error(addResult.description || "Error agregando al carrito");
  }

  const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
    method: "GET",
    credentials: "include"
  });
  const cartState = await cartResponse.json();

  // Replica el feedback que usa el theme tras add-to-cart.
  if (typeof window.emit === "function") {
    window.emit("quick-cart:updated");
    window.emit("cart:updated", { cart: cartState });
  }
  document.dispatchEvent(new CustomEvent("quick-cart:updated"));
  document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartState } }));

  return cartState;
}

function getCreatedProductFromResponse(responseJson) {
  if (!responseJson || typeof responseJson !== "object") return null;
  if (responseJson.product) return responseJson.product;
  if (responseJson.result && responseJson.result.product) return responseJson.result.product;
  return null;
}

async function resolveCreatedVariantId(responseJson) {
  const product = getCreatedProductFromResponse(responseJson);

  const directVariantId =
    (product && product.variants && product.variants[0] && product.variants[0].id) ||
    null;

  if (directVariantId) {
    return directVariantId;
  }

  const productHandle = product && product.handle ? product.handle : null;
  if (!productHandle) return null;

  const productBasePath =
    (window.theme && window.theme.routes && window.theme.routes.products) ||
    "/products";

  for (let attempt = 0; attempt < 5; attempt++) {
    try {
      const response = await fetch(`${productBasePath}/${productHandle}.js`, {
        method: "GET",
        credentials: "include"
      });

      if (response.ok) {
        const storefrontProduct = await response.json();
        const storefrontVariantId =
          (storefrontProduct && storefrontProduct.variants && storefrontProduct.variants[0] && storefrontProduct.variants[0].id) ||
          null;

        if (storefrontVariantId) {
          return storefrontVariantId;
        }
      }
    } catch (error) {
      console.warn("No se pudo resolver variante por handle en intento", attempt + 1, error);
    }

    await new Promise((resolve) => setTimeout(resolve, 350));
  }

  return null;
}

async function refreshThemeHeaderCartFeedback() {
  const headerSection = document.querySelector("#shopify-section-header");
  if (!headerSection || !window.theme || !window.theme.routes || !window.theme.routes.root) return;

  const sectionId = headerSection.id.replace("shopify-section-", "");
  const response = await fetch(`${window.theme.routes.root}?section_id=${sectionId}`, { method: "GET" });
  const html = await response.text();
  const container = document.createElement("div");
  container.innerHTML = html;

  updateInnerHTMLFromContainer(".header__content-mobile [data-header-cart]", container);
  updateInnerHTMLFromContainer(".header__content-desktop [data-header-cart]", container);
}

const PRODUCT_TYPE_COTIZA_CORTINA = "Cotiza Cortina";

/**
 * Formatea un número a un string con puntos como separadores de miles.
 *
 * @param {number} num - El número a formatear.
 * @returns {string} El número formateado.
 */
function formatPrice(num) {
  return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
}

/**
 * Actualiza el mini carro
 *
 * @param {boolean} show  Muestra el menu
 * @param {boolean} all   Actualiza el sector medio del mini carro
 * @param {boolean} quote
 */
function update_mini_cart(show = false, all = true, quote = false) {
  let cotizacion_total = 0;

  jQuery.get("/cart.js", function(data) {
    const hasQuoteProduct = data.items.some(item => item["product_type"] === PRODUCT_TYPE_COTIZA_CORTINA);
    quote = quote || hasQuoteProduct;

    if (quote) {
      cotizacion_total = data.items.reduce((acc, item) => acc + parseFloat(item["final_line_price"]), 0);
    }

    const total = formatPrice(data.total_price ? Math.floor(data.total_price / 100) : 0);
    if (quote || total === '0') {
      const cotización_total_format = formatPrice(cotizacion_total ? Math.floor(cotizacion_total / 100) : 0);
      $(".inner-cotizacion-total span").html('$' + cotización_total_format);
      if (cotizacion_total === 0) {
        $(".btn.print").removeClass("show");
        $(".inner-cotizacion-content").empty();
      }
    }
  }, 'json');
}

var $easyzoom = $('.easyzoom').easyZoom({
  loadingNotice: 'Cargando imagen'
});

$(document).on('change', '.quantity-cotizador', function() {
  const quantity = $(this).val();
  const id = $(this).data('product-id');

  if (quantity > 0) {
    $(`.inner-cotizacion-container[data-product-id='${id}'] .val-quantity`).html(` ${quantity}`)
  } else {
    $(`.inner-cotizacion-container[data-product-id='${id}']`).remove();
  }
});

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/*============================================================================
  Video section
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    var $videoElement,
        settings;

    //Check for videos that are set to autoplay
    $('.homepage-video').each(function (index, value) {
      if ($('.homepage-video').length && supports_video()) {

        $videoElement = $(this);

        settings = videoSection.getVideoSettings($videoElement);

        if (is_touch_device() && $(window).width() <= 798 && settings.posterImage === false || $(window).width() <= 798 && settings.posterImage === false) {
          //add video element on small screens if there is no poster image
          videoSection.appendFrame($videoElement, settings);
        } else if (settings.autoPlayVideo && $(window).width() > 798){
          //add video element when autoplay is true and it's on a larger screen
          videoSection.appendFrame($videoElement, settings);
        } else if (settings.autoPlayVideo === false && settings.posterImage === false){
          //add video element when autoplay is false but there is no poster image
          videoSection.appendFrame($videoElement, settings);
        } else {
          //Show poster image on smaller sceens and when it exists
          $videoElement.find('.homepage-video__placeholder').show();
          $videoElement.find('.placeholder-svg--video').show();
        }

      }
    });

    //Attach event listener for videos
    $('body').on('click', '.video__play-button', function(e) {
      $videoElement = $(this).parents('.video-section').find('.homepage-video');
      $(this).fadeOut();
      settings = videoSection.getVideoSettings($videoElement);
      if ($videoElement.find('.mediaWrapper').length < 1 && $videoElement.find('video').length < 1){
        videoSection.appendFrame($videoElement, settings);
      }
    });

    $('body').on('click', '[data-play-video]', function(e) {
      $videoElement = $(this).parents('.video-section').find('.homepage-video');
      $(this).fadeOut();
      settings = videoSection.getVideoSettings($videoElement);
      if ($videoElement.find('.mediaWrapper').length < 1 && $videoElement.find('video').length < 1){
        videoSection.appendFrame($videoElement, settings);
      }
    });
  },
  getVideoSettings: function($videoElement){
    var settings = {
      container: $videoElement.find('.homepage-video'),
      header: $videoElement.find('.homepage-video--media'),
      posterImage: $videoElement.data('poster-image'),
      videoText: $videoElement.find('.homepage-video--media .caption'),
      videoTrigger: $videoElement.find("[data-play-video]"),
      autoPlayVideo: $videoElement.data('autoplay'),
      displayTextOverVideo: $videoElement.data('display-text-over-video'),
      autoloop: $videoElement.data('autoloop'),
      id: $videoElement.attr('data-video-src'),
      aspectRatio: $videoElement.attr('data-aspect-ratio').split(":"),
      provider: $videoElement.attr('data-provider').toLowerCase(),
      videoMP4: $videoElement.attr('data-video-mp4'),
      videoOGV: $videoElement.attr('data-video-ogv')
    }
    return settings;
  },
  createFrame: function(settings){
    var autoloop,
        controls,
        html,
        autoplay,
        poster = '';

    if(settings.provider === 'youtube') {
      if (settings.autoloop){
        autoloop = '1&iv_load_policy=3&playlist='+settings.id;
      } else {
        autoloop = 0;
      }

      if (settings.posterImage === false && settings.autoPlayVideo === false){
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      controls = 1;

      html = '<iframe src="//www.youtube.com/embed/'+settings.id+'?&autoplay='+autoplay+'&loop='+autoloop+'&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(settings.provider === 'vimeo') {

      if (settings.posterImage === false && settings.autoPlayVideo === false){
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      if (settings.autoloop){
        autoloop = 1;
      } else {
        autoloop = 0;
      }
      html = '<iframe src="//player.vimeo.com/video/'+settings.id+'?loop='+autoloop+'&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay='+autoplay+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(settings.provider === 'html5') {

      if (settings.posterImage !== false){
        poster = ' poster="https://' + settings.posterImage;
      }

      if (settings.posterImage === false && settings.autoPlayVideo === false && is_touch_device() === 0){
        autoplay = ' ';
      } else if (settings.autoPlayVideo && settings.posterImage !== false){
        poster = ' poster="https://' + settings.posterImage;
        autoplay = ' autoplay ';
      } else {
        autoplay = ' autoplay ';
      }

      if (settings.autoloop){
        autoloop = ' loop="loop" ';
      }

      controls = '';

      html = '<video '+ controls + autoplay + autoloop + poster +' id="video" onclick="this.paused?this.play():this.pause();" ><source src="'+settings.videoMP4+'" type="video/mp4"><source src="'+settings.videoOGV+'" type="video/ogg" ></video>';
    }
    return html;
  },
  appendFrame: function($videoElement, settings){

    var mediaWrapper;

    if (settings.displayTextOverVideo === false){
      settings.videoText.fadeOut();
    }

    $videoElement.find('.video__play-button').fadeOut();


    $videoElement.append(videoSection.createFrame(settings));

    if (settings.provider != 'html5'){
      var paddingBottomValue = settings.aspectRatio[1] / settings.aspectRatio[0] * 100 + '%';

      if (typeof $().mediaWrapper !== 'undefined') {
        $videoElement.find('iframe').mediaWrapper({
          intrinsic: false,
          baseWidth : settings.aspectRatio[0],
          baseHeight: settings.aspectRatio[1]
        });
      }

      $videoElement.css({
        height: 0,
        paddingBottom: paddingBottomValue
      });

    } else {
      $videoElement.find('.homepage-video__image').hide();
    }

  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
  }
}

videoSection.init();
